/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component, useRef } from "react";
import classes from "./product.module.css";
import Detail from "./detail/detail";
import Stepper from "../../../component/stepper";
import BusApiCall from "../../../helper/axios";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Loader from "../../../component/loader";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Grid from "@mui/material/Grid";
import Carousel from "./main/carousel";
import Select from "../../../component/select";
import SelectM from "@mui/material/Select";
import Button from "../../../component/button";

import InlineItem from "./inlineItem/inlineItem";
import Input from "../../../component/inputpm";
import jp, { value } from "jsonpath";
import currencyFormatter from "../../../helper/currencyFormatter";
import PreQualificationVerification from "./preQualificationVerification";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  DialogContentText,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Tooltip, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import { Autocomplete } from "@mui/material";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Chip from "@mui/material/Chip";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CustomerDetails from "../checkout/customerDetails/customerDetails";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import UriEncode from "../../../component/uriEncode/uriEncode";
import StepperNew from "../../../component/stepper/stepperNew";
import { EditIconNew, PlusIcon } from "../../../component/icons/icons";
// import { withStyles } from '@mui/styles';
import OfferingProductSpecCharacteristicsDialog from "../../pm/component/specification/offeringProductSpecCharacteristicsDialog";
import OfferingProductSpecCharacteristicsExistingDialog from "../../pm/component/specification/offeringProductSpecCharacteristicsExistingDialog";
import { withNavigation } from "../../../helper/withNavigation";
import DraggableResizablePaper from "../../../component/resizablePaper/resizablePaper";
import Switch from "@mui/material/Switch";

// This is the parent class for product wizard, all components inside the product wizard are centralized here
class Product extends Component {
  // Declare property values that belongs to the component
  state = {
    product: {},
    steps: [],
    stepsCopy: [],
    activeStep: 0,
    features: [],
    name: "",
    lastStep: "",
    images: [],
    description: "",
    releaseDate: "",
    hasAccessories: true,
    comments: "",
    startingPrice: 0,
    longDescription: "",
    id: "",
    implicitDataPlans: [],
    variants: [],
    accessories: [],
    allAccessories: [],
    firstLevelFeatures: [],
    quantity: 1,
    onlyAcc: false,
    onlyAddons: false,
    loading: false,
    selectedPromo: "",
    promos: [],
    solutions: {
      options: [],
    },
    overView: "",
    techSpecs: "",
    whatsIncluded: "",
    customAccessoryId: "",
    addonsOnlyOrder: false,
    accessoriesOnlyOrder: false,
    isAccessoriesSelected: false,
    overrideStartingPrice: false,
    sortPlansByPrice: true,
    setupSelectionType: "single",
    isSetupRequired: true,
    packageMode: "",
    bread: [],
    mPriceDisp: "",
    renderView: false,
    showSteps: false,
    userStepperAction: "NEXT",
    selectionType: {},
    selectionTypeMinLimit: {},
    selectionTypeMaxLimit: {},
    availableItemCount: 0,
    providerId: "",
    parentTenantId: "",
    allPromosList: [],
    componentTypeList: [],
    assembly: false,
    isBundle: true,
    openVerifyDialog: false,
    preQualsData: {},
    preQualMessage: "",
    showCheckAvailability: false,
    placeOrder: true,
    orginalPreQuals: [],

    stage: 0,
    selectedTreeItems: [],
    customerDetails: {},
    selectedPaymentMethod: null,
    onSelectCustomerCallback: null,

    showSelectCustomer: false,
    auxiliaryProducts: [],
    selectedAuxiliaryProducts: [],
    showNewCustomer: false,
    newCustomerDetails: {},
    language: "",
    localisedOverview: [],
    localisedTechSpecs: [],
    localisedWhatsIncluded: [],
    showAuxiliaryBucket: false,
    offeringCustomer: "",
    hasInfo: true,
    showImage: false,
    err: "",
    quotedData: null,
    unsaveQuoteChanges: false,
    showChangesWarning: false,
    noOverview: false,
    noTechspecs: false,
    noWhatsincluded: false,
    subsciptionData: {},
    isSubscriptionMode: false,
    isReviseQuoteMode: false,
    modules: {},

    oldChangeSubscriptionData: {},
    disableQuantityInput: false,

    allowedSate: [],
    state: "",
    specialPricingCode: null,
    isLeadQuote: false,
    leadData: {},
    disableCreateQuote: false,

    showSpecification: false,
    selectedProductSpecification: {},
    selectedCharacteristics: [],
    showOfferingQuantity: true,
    hideAutoSelectedProducts: true,
    openResetConfirmDialog: false,
    originalOfferingData: {},

    quantityValidationAttr: {},
    showProductsDescription: false,
    showOfferingQty: false
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    //get allowed states for order
    var jsonData = {};
    // BusApiCall('POST', `${constants.busInternalUrl}/passthru/GET_ALLOWED_ORDER_STATES/endpoint`, jsonData).then(res => {
    //     this.setState({
    //         allowedSate: res.data.stateList
    //     })
    // })
    //     .catch(err => {
    //         if (err.response && err.response.data && err.response.data.message) {
    //             this.props.setErrorMessage(err.response.data.message, false)
    //         } else {
    //             this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
    //         }
    //         this.setState({ loading: false });
    //     })
    this.setState({
      showOfferingQuantity: this.props.showOfferingQuantity
    })
    var modules = JSON.parse(localStorage.getItem("modules"));
    console.log('check this.props', this.props.router.location.state);
    this.setState({ modules: modules ? modules : {} });
    var isSubscriptionMode = false;
    var isReviseQuoteMode = false;
    var isLeadQuote = false;
    if (
      this.props.router.location.state &&
      this.props.router.location.state.subsciptionData &&
      this.props.router.location.state.subsciptionData.mode
    ) {
      isSubscriptionMode = true;
      this.setState(
        {
          isSubscriptionMode: true,
          subsciptionData: this.props.router.location.state.subsciptionData,
          disableQuantityInput: this.props.router.location.state.subsciptionData
            .nonEditableItem
            ? this.props.router.location.state.subsciptionData.nonEditableItem
            : false,
        },
        () => {
          this.getCustomerCart(this.state.subsciptionData.partyId);
        },
      );
    }
    if (this.props.router.location.state && this.props.router.location.state.isLeadQuote) {
      isLeadQuote = true;
      this.setState({
        isLeadQuote: true,
        leadData: this.props.router.location.state.leadData,
      });
    }
    if (this.props.router.location.state && this.props.router.location.state.originalQuoteId) {
      isReviseQuoteMode = true;
      this.setState({
        isReviseQuoteMode: true,
        disableQuantityInput: this.props.router.location.state.nonEditableItem
          ? this.props.router.location.state.nonEditableItem
          : false,
      });
    }
    // Remove error message on component load
    this.props.setCompDidMount();
    // Start loading while fetching data
    this.setState({ loading: true });
    // Fetch product id from URL Params
    let id = this.props.router.params.id;
    this.setState({
      id,
    });
    if (isSubscriptionMode || isLeadQuote) {
    } else {
      var preSelectedCustomer = JSON.parse(
        localStorage.getItem("preSelectedCustomer"),
      );
      if (preSelectedCustomer && preSelectedCustomer.partyId) {
        this.setState({
          customerDetails: preSelectedCustomer,
        });
      }
    }

    //set packageMode to state for view purpose (when sales channel provier opts to view the package solution)
    let search = new URLSearchParams(this.props.router.location.search);
    let packageMode = search.get("packageMode");
    const { state } = this.props.router.location;
    var parentTenantId = "";
    if (state && state.parentTenantId) {
      parentTenantId = state.parentTenantId;
    }
    if (this.props.providerType !== "SALES_CHNL_PROVIDER") {
      packageMode = "view";
    }

    if (state && state.productQuoted && state.productQuoted.id) {
      this.setState({
        quantity: state.productQuoted.quantity,
      });
    }
    if (
      state &&
      state.productQuoted &&
      state.productQuoted.specialPricingCode
    ) {
      this.setState({
        specialPricingCode: state.productQuoted.specialPricingCode,
      });
    }
    this.setState(
      {
        parentTenantId,
        packageMode: packageMode,
        quotedData:
          state && state.productQuoted && state.productQuoted.id ? state : null,
      },
      () => {
        // this.getOfferingData();
        if (isSubscriptionMode || isReviseQuoteMode || isLeadQuote) {
          this.getOfferingData();
        } else {
          this.checkCustomerList();
        }
      },
    );
  }
  setSelectCustomerCallback = (callback) => {
    this.onSelectCustomerCallback = callback;
  };
  checkCustomerList = () => {
    var inheritedCustomers = [];
    var preSelectedCustomer = JSON.parse(
      localStorage.getItem("preSelectedCustomer"),
    );
    if (
      this.props.router.location.state &&
      this.props.router.location.state.availableCustomers &&
      this.props.router.location.state.availableCustomers.length > 0
    ) {
      inheritedCustomers = this.props.router.location.state.availableCustomers;
      if (preSelectedCustomer && preSelectedCustomer.ban) {
        if (preSelectedCustomer.parentId) {
          if (inheritedCustomers.includes(preSelectedCustomer.parentId)) {
            this.getOfferingData();
            this.getCustomerCart(preSelectedCustomer.partyId);
            this.setState(
              {
                offeringCustomersList: inheritedCustomers,
                showSelectCustomer: false,
                customerDetails: preSelectedCustomer,
              },
              () => { },
            );
          } else {
            localStorage.removeItem("preSelectedCustomer");
            this.setState(
              {
                offeringCustomersList: inheritedCustomers,
                customerDetails: {},
              },
              () => {
                this.setState({
                  showSelectCustomer: true,
                  loading: false,
                });
              },
            );
          }
        } else {
          if (inheritedCustomers.includes(preSelectedCustomer.partyId)) {
            this.getOfferingData();
            this.getCustomerCart(
              preSelectedCustomer.partyId,
              preSelectedCustomer.ban,
            );
            this.setState(
              {
                offeringCustomersList: inheritedCustomers,
                showSelectCustomer: false,
                customerDetails: preSelectedCustomer,
              },
              () => { },
            );
          } else {
            localStorage.removeItem("preSelectedCustomer");
            this.setState(
              {
                offeringCustomersList: inheritedCustomers,
                customerDetails: {},
              },
              () => {
                this.setState({
                  showSelectCustomer: true,
                  loading: false,
                });
              },
            );
          }
        }
      } else {
        this.setState(
          {
            offeringCustomersList: inheritedCustomers,
            customerDetails: {},
          },
          () => {
            this.setState({
              showSelectCustomer: true,
              loading: false,
            });
          },
        );
      }
    } else {
      if (preSelectedCustomer && preSelectedCustomer.ban) {
        this.getOfferingData();
        this.getCustomerCart(
          preSelectedCustomer.partyId,
          preSelectedCustomer.ban,
        );
        this.setState(
          {
            showSelectCustomer: false,
            customerDetails: preSelectedCustomer,
          },
          () => { },
        );
      } else {
        this.setState(
          {
            customerDetails: {},
            showSelectCustomer: true,
            loading: false,
          },
          () => { },
        );
      }
    }
    // if (!this.props.publicBrowsing) {
    //     const { state } = this.props.router.location;
    //     var offeringCustomer = '';
    //     if (state && state.offeringCustomer) {
    //         offeringCustomer = state.offeringCustomer;
    //     } else {
    //         offeringCustomer = res.customer && res.customer.length > 0 ? res.customer[0] : '';
    //     }
    //     var preSelectedCustomer = JSON.parse(localStorage.getItem('preSelectedCustomer'));
    //     if (preSelectedCustomer && preSelectedCustomer.ban) {
    //         if (offeringCustomer) {
    //             if (preSelectedCustomer.partyId === offeringCustomer) {
    //                 this.getCustomerCart(preSelectedCustomer.partyId);
    //                 this.setState({
    //                     showSelectCustomer: false,
    //                     customerDetails: preSelectedCustomer,
    //                     offeringCustomer
    //                 })
    //             } else {
    //                 localStorage.removeItem("preSelectedCustomer");
    //                 this.setState({
    //                     showSelectCustomer: true,
    //                     offeringCustomer
    //                 })
    //             }
    //         } else {
    //             this.getCustomerCart(preSelectedCustomer.partyId);
    //             this.setState({
    //                 showSelectCustomer: false,
    //                 customerDetails: preSelectedCustomer,
    //                 offeringCustomer
    //             })
    //         }
    //     } else {
    //         this.setState({
    //             showSelectCustomer: true,
    //             offeringCustomer
    //         })
    //     }
    // }
  };

  getOfferingData = () => {
    this.setState({
      loading: true,
    });
    let jsonData = {};
    if (this.state.parentTenantId) {
      jsonData = {
        tenantId: this.state.parentTenantId,
      };
    }
    var tempCustomerId = "";
    if (this.state.isSubscriptionMode) {
      tempCustomerId = this.state.subsciptionData.partyId;
    } else if (this.state.isReviseQuoteMode) {
      tempCustomerId = this.state.quotedData.relatedParty.id;
    } else {
      tempCustomerId =
        this.state.customerDetails && this.state.customerDetails.partyId
          ? this.state.customerDetails.partyId
          : "";
    }
    BusApiCall(
      "GET",
      `${constants.busV4Url}/catalog/myComponentTypes`,
      jsonData,
    )
      .then((res) => {
        let data = res.data;
        let cData = JSON.parse(data.jsonResponse);
        let componentTypeList = [];
        if (cData && cData.length > 0) {
          componentTypeList = [...cData];
          BusApiCall(
            "GET",
            `${constants.busInternalUrl}/promos/packaged-solutions/${this.state.id}`,
            jsonData,
          )
            .then((promoRes) => {
              var allPromos = [];
              if (
                this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                this.props.loggedInUserType === "ECOMMERCE_ADMIN"
              ) {
                if (promoRes.data && promoRes.data.length > 0) {
                  for (var i = 0; i < promoRes.data.length; i++) {
                    if (
                      promoRes.data[i].partyId &&
                      promoRes.data[i].partyId === "all"
                    ) {
                      allPromos.push(promoRes.data[i]);
                    } else if (
                      promoRes.data[i].partyId &&
                      promoRes.data[i].partyId ===
                      this.props.ecommerceCustData.partyId
                    ) {
                      allPromos.push(promoRes.data[i]);
                    }
                  }
                }
              } else {
                if (promoRes.data && promoRes.data.length > 0) {
                  for (var i = 0; i < promoRes.data.length; i++) {
                    if (
                      promoRes.data[i].partyId &&
                      promoRes.data[i].partyId === "all"
                    ) {
                      allPromos.push(promoRes.data[i]);
                    } else if (
                      promoRes.data[i].partyId &&
                      promoRes.data[i].partyId === tempCustomerId
                    ) {
                      allPromos.push(promoRes.data[i]);
                    }
                  }
                }
              }
              this.setState({
                allPromosList: allPromos,
                componentTypeList,
              });
              BusApiCall(
                "GET",
                `${constants.busInternalUrl}/catalog/products/${this.state.id}/packagedSolutions?${tempCustomerId ? "customerId=" + tempCustomerId : ""}`,
                jsonData,
              )
                .then((response) => {
                  let res = JSON.parse(response.data.jsonResponse);
                  console.log("check product data test", res);

                  // if (res.basicDetail && res.basicDetail.customAttributes && res.basicDetail.customAttributes.length > 0) {
                  //   var atIndex = res.basicDetail.customAttributes.findIndex(a => a.attrName === "quantityValidation");
                  //   if (atIndex !== -1) {
                  //     this.setState({
                  //       quantityValidationAttr: res.basicDetail.customAttributes[atIndex]
                  //     })
                  //   }
                  // }

                  if (
                    res.basicDetail &&
                    Array.isArray(res.basicDetail.customAttributes) &&
                    res.basicDetail.customAttributes.length > 0
                  ) {
                    const matchedAttrs = res.basicDetail.customAttributes.filter(
                      (attr) => attr.attrName?.includes("quantityValidation")
                    );

                    if (matchedAttrs.length > 0) {
                      const combinedAttr = {
                        ...matchedAttrs[0],
                        attrValue: matchedAttrs.map((attr) => attr.attrValue).join(",")
                      };

                      this.setState({
                        quantityValidationAttr: combinedAttr
                      });
                    }
                  }


                  let overViewObj = JSON.parse(res.basicDetail.productOverview);
                  let techSpecsObj = JSON.parse(
                    res.basicDetail.productTechSpecs,
                  );
                  let whatsIncludedObj = JSON.parse(
                    res.basicDetail.productWhatsIncluded,
                  );
                  let showImage = res.basicDetail.productMainImage
                    ? true
                    : false;
                  let state = res.status;
                  this.setState({
                    state: state,
                    showImage: showImage,
                  });
                  let isBundle = res.basicDetail.bundle;
                  if (
                    !isBundle &&
                    !overViewObj.blocks[0].text &&
                    !techSpecsObj.blocks[0].text &&
                    !whatsIncludedObj.blocks[0].text
                  ) {
                    this.setState({
                      hasInfo: false,
                      showSteps: true,
                    });
                  }
                  let tempPromos = [];
                  var availablePromos = [];
                  if (
                    this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                    this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                  ) {
                    if (res.promos && res.promos.length > 0) {
                      for (var i = 0; i < res.promos.length; i++) {
                        if (
                          res.promos[i].partyId &&
                          res.promos[i].partyId === "all"
                        ) {
                          availablePromos.push(res.promos[i]);
                        } else if (
                          res.promos[i].partyId &&
                          res.promos[i].partyId ===
                          this.props.ecommerceCustData.partyId
                        ) {
                          availablePromos.push(res.promos[i]);
                        }
                      }
                    }
                  } else {
                    // availablePromos = res.promos ? res.promos : [];
                    if (res.promos && res.promos.length > 0) {
                      for (var i = 0; i < res.promos.length; i++) {
                        if (res.promos[i].customer === "all") {
                          availablePromos.push(res.promos[i]);
                        } else if (res.promos[i].customer === tempCustomerId) {
                          availablePromos.push(res.promos[i]);
                        }
                      }
                    } else {
                      availablePromos = [];
                    }
                  }
                  if (
                    availablePromos &&
                    availablePromos.length > 0 &&
                    allPromos &&
                    allPromos.length > 0
                  ) {
                    for (let i = 0; i < availablePromos.length; i++) {
                      let index = allPromos.findIndex(
                        (a) => a.id === availablePromos[i].id,
                      );
                      if (index !== -1) {
                        if (allPromos[index].type === "VOLUME_PRICING") {
                        } else {
                          if (
                            index >= 0 &&
                            allPromos[index].type === "OPEX_PRICING"
                          ) {
                            // availablePromos[i].text = availablePromos[i].text + ' (Opex Pricing - ' + allPromos[index].opexTenureMonths + ' Months)';
                            let tenureObject = {
                              text: availablePromos[i].text,
                              tenure: allPromos[index].opexTenureMonths,
                            };
                            availablePromos[i].text = this.props.t(
                              "OPEX_PRICING_FORMAT",
                              { tenureObject },
                            );
                          } else {
                            availablePromos[i].text =
                              availablePromos[i].text +
                              " (" +
                              this.props.t("CUSTOM_PRICING") +
                              ")";
                          }
                          tempPromos.push(availablePromos[i]);
                        }
                      }
                    }
                  }
                  // Check for special pricing code and assign the matching promo to selectedPromo
                  if (this.state.specialPricingCode) {
                    const matchingPromo = availablePromos.find(
                      (promo) => promo.id === this.state.specialPricingCode,
                    );

                    if (matchingPromo) {
                      this.setState({
                        selectedPromo: matchingPromo,
                      });
                    }
                  }
                  var preQualsData = [];
                  if (this.props.publicBrowsing) {
                  } else {
                    if (res.preQuals && res.preQuals.length > 0) {
                      for (var i = 0; i < res.preQuals.length; i++) {
                        var pre = {
                          resourceId: res.preQuals[i].resourceId,
                          parameters: JSON.parse(res.preQuals[i].parameters),
                          resourceName: res.preQuals[i].resourceName,
                          productId: res.productId,
                          productName: res.basicDetail.productName,
                        };
                        preQualsData.push(pre);
                      }
                    }
                  }
                  if (res.components && res.components.length > 0) {
                    for (var i = 0; i < res.components.length; i++) {
                      // if (res.components[i].productSpec && res.components[i].productSpec.category && res.components[i].productSpec.category.id === 'PSC_CUST_FACING') {
                      //     const filteredJson = this.filterChildSpecs(res.components[i].productSpec);
                      //     res.components[i].productSpec = filteredJson;
                      // } else {
                      //     res.components[i].productSpec = {};
                      // }

                      // const filteredJson = this.filterChildSpecs(res.components[i].productSpec);
                      // res.components[i].productSpec = filteredJson;
                      // console.log('check updated specs', this.filterChildSpecs(res.components[i].productSpec));

                      const cleanedData = this.filterChildSpecs(
                        res.components[i].productSpec,
                      );
                      res.components[i].productSpec = cleanedData;
                      if (
                        res.components[i].preQuals &&
                        res.components[i].preQuals.length > 0
                      ) {
                        for (
                          var j = 0;
                          j < res.components[i].preQuals.length;
                          j++
                        ) {
                          var pre = {
                            resourceId:
                              res.components[i].preQuals[j].resourceId,
                            parameters: JSON.parse(
                              res.components[i].preQuals[j].parameters,
                            ),
                            resourceName:
                              res.components[i].preQuals[j].resourceName,
                            productId: res.components[i].id,
                            productName: res.components[i].name,
                          };
                          preQualsData.push(pre);
                        }
                      }
                    }
                  }
                  this.setState({
                    loading: false,
                    promos: availablePromos ? tempPromos : [],
                    providerId: res.basicDetail.providerId,
                    assembly: res.basicDetail.assembly,
                    isBundle: res.basicDetail.bundle,
                    localisedName: res.basicDetail.localisedName,
                    localisedDesc: res.basicDetail.localisedDesc,
                    localisedOverview: res.basicDetail.localisedOverview,
                    localisedTechSpecs: res.basicDetail.localisedTechSpecs,
                    showOfferingQty: res.basicDetail.showOfferingQty ? res.basicDetail.showOfferingQty : false,
                    localisedWhatsIncluded:
                      res.basicDetail.localisedWhatsIncluded,
                    preQualsData,
                    orginalPreQuals:
                      res.preQuals && res.preQuals.length > 0
                        ? res.preQuals
                        : [],
                    showCheckAvailability:
                      preQualsData.length > 0 ? true : false,
                    placeOrder: preQualsData.length > 0 ? false : true,
                    originalOfferingData: structuredClone(res)
                  });
                  if (res) {
                    this.setProductData(componentTypeList, res);
                  }
                })
                .catch((err) => {
                  if (
                    err.response &&
                    err.response.data &&
                    err.response.data.message
                  ) {
                    this.props.setErrorMessage(
                      err.response.data.message,
                      false,
                    );
                  } else {
                    this.props.setErrorMessage(
                      this.props.t("DEFAULT_ERROR_MESSAGE"),
                      false,
                    );
                  }
                  this.setState({ loading: false });
                });
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({ loading: false });
            });
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  filterChildSpecs = (data) => {
    // if (!spec.productSpecificationRelationship) return spec;

    // // Keep only productSpecificationRelationship with category === "PSC_CUST_FACING"
    // spec.productSpecificationRelationship = spec.productSpecificationRelationship
    //     .filter(child => child.category && child.category.id === 'PSC_CUST_FACING')
    //     .map(child => this.filterChildSpecs(child)); // Recurse!

    // return spec;

    // Base case: if the object has a category and it's not PSC_CUST_FACING
    if (data.category?.id !== "PSC_CUST_FACING") {
      data.productSpecCharacteristic = [];
    }

    // If there are productSpecificationRelationship, apply recursively
    if (Array.isArray(data.productSpecificationRelationship)) {
      data.productSpecificationRelationship.forEach(this.filterChildSpecs);
    }

    return data;
  };

  draggableDialogPaper = (props) => {
    const nodeRef = useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        bounds={"parent"}
        defaultClassName="customReactDraggableComponent"
        handle="#draggableDialogPaper"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
  };

  setProductData = (componentTypeList, productData) => {
    this.setState({ loading: true });
    // Fetch product id from URL Params
    let id = this.props.router.params.id;
    let productId = productData.productId;

    //add the PKG type to the list to be sorted
    componentTypeList.push({
      id: "PROD_COMP_PACKAGE",
      name: "Package",
      label: "Package",
      iconName: "local_mall",
      sequenceNum: 9998,
    });

    let sortedComponentList = componentTypeList.sort((a, b) =>
      a.sequenceNum > b.sequenceNum
        ? 1
        : b.sequenceNum > a.sequenceNum
          ? -1
          : 0,
    );
    let steps = [];
    /*for (var i = 0; i < sortedComponentList.length; i++) {
            steps.push({ name: sortedComponentList[i].id, label: sortedComponentList[i].displayNamePlural })
        }*/

    let tempComponentData = productData.components;
    let componentData = [];
    let revisedComponentTypeList = [];
    let auxiliaryProductsArray = [];

    let selectionType = {};
    let tempSelectionType = { ...productData.selectionType };
    Object.keys(tempSelectionType).map(function (key, index) {
      selectionType[key.replace("selectionType_", "")] = tempSelectionType[key];
    });

    let selectionTypeMinLimit = {};
    let tempSelectionTypeMinLimit = { ...productData.selectionTypeMinLimit };
    Object.keys(tempSelectionTypeMinLimit).map(function (key, index) {
      selectionTypeMinLimit[key.replace("minLimit_", "")] = tempSelectionTypeMinLimit[key];
    });

    let selectionTypeMaxLimit = {};
    let tempSelectionTypeMaxLimit = { ...productData.selectionTypeMaxLimit };
    Object.keys(tempSelectionTypeMaxLimit).map(function (key, index) {
      selectionTypeMaxLimit[key.replace("maxLimit_", "")] = tempSelectionTypeMaxLimit[key];
    });

    sortedComponentList.forEach((key, index) => {
      let componentCount = 0;
      tempComponentData = tempComponentData.filter((item) => {
        item.quantity = 0;
        let tempPrice = item.price;
        // if (item.priceType === 'NTC') {
        //     item.priceType = 'NRC';
        // }
        if (item.variants && item.variants.length > 0) {
          for (var v = 0; v < item.variants.length; v++) {
            item.variants[v].id = item.variants[v].productId;
            item.variants[v].priceType = item.priceType;
            item.variants[v].price = this.setTempPrice(
              item.variants[v].price,
              item.priceType,
            );
          }
        }
        // Create temporary price object
        if (tempPrice && typeof tempPrice !== "object") {
          item.originalPrice = tempPrice;
          item.originalPriceType = item.priceType;
          item.price = this.setTempPrice(tempPrice, item.priceType);
        }
        // Set default selected for items directly depended on packaged solution
        if (
          item.relationShips &&
          item.relationShips.dependsOn &&
          item.relationShips.dependsOn.length > 0
        ) {
          let defaultDepender = jp.query(
            item.relationShips.dependsOn,
            '$..[?(@.depender=="' + id + '")]',
          );
          if (defaultDepender.length > 0) {
            if (defaultDepender[0].dependencyType === "Mandatory") {
              item.selected = true;
              item.defaultSelected = true;
              item.isCoreItem = true;
              item.trulyCoreItem = true;
              if (item.variants && item.variants.length > 0) {
                item.variants[0].selected = true;
              }
            }
            if (defaultDepender[0].cardinality.type === "Exact") {
              item.isExact = true;
            } else {
              item.isExact = false;
            }
            // item.quantity = defaultDepender[0].cardinality.range.min === 0 ? 1 : defaultDepender[0].cardinality.range.min;
            if (
              defaultDepender[0].cardinality &&
              defaultDepender[0].cardinality.type === "Range"
            ) {
              item.quantity =
                defaultDepender[0].cardinality.range.min === 0
                  ? 1
                  : defaultDepender[0].cardinality.range.min;
              item.maxQuantity =
                defaultDepender[0].cardinality.range.max === 0
                  ? 1
                  : defaultDepender[0].cardinality.range.max;
            } else {
              item.quantity =
                defaultDepender[0].cardinality.range.min === 0
                  ? 1
                  : defaultDepender[0].cardinality.range.min;
            }
          }
        }
        // If standalone sellable then select component by defualt
        if (!productData.basicDetail.bundle) {
          item.selected = true;
          item.defaultSelected = true;
          item.isCoreItem = true;
          item.trulyCoreItem = true;
          item.isExact = false;
          item.quantity = 1;
        }
        // Set min quantity for first bucket items
        if (item.componentType === key.id) {
          if (index === 0) {
            if (
              item.relationShips &&
              item.relationShips.dependsOn &&
              item.relationShips.dependsOn.length > 0
            ) {
              if (
                item.relationShips.dependsOn[0].dependencyType === "Mandatory"
              ) {
                item.quantity =
                  item.relationShips.dependsOn[0].cardinality.range.min === 0
                    ? 1
                    : item.relationShips.dependsOn[0].cardinality.range.min;
              }
            } else {
              item.quantity = 1;
            }
          } else {
            if (
              item.relationShips &&
              item.relationShips.dependsOn &&
              item.relationShips.dependsOn.length > 0
            ) {
            } else {
              item.quantity = 1;
            }
          }

          // if user want to review and edit quote
          if (
            this.state.quotedData &&
            this.state.quotedData.productQuoted &&
            this.state.quotedData.productQuoted.id
          ) {
            var qoutedSelectedComponents =
              this.state.quotedData.productQuoted.includedItems;
            if (item.variants && item.variants.length > 0) {
              for (var v = 0; v < item.variants.length; v++) {
                var cIndex = qoutedSelectedComponents.findIndex(
                  (x) => x.id === item.variants[v].productId,
                );
                if (cIndex > -1) {
                  item.variants[v].selected = true;
                  item.selected = true;
                  item.quantity = qoutedSelectedComponents[cIndex].quantity;
                }
              }
            } else {
              var cIndex = qoutedSelectedComponents.findIndex(
                (x) => x.id === item.id,
              );
              if (cIndex > -1) {
                item.selected = true;
                item.quantity = qoutedSelectedComponents[cIndex].quantity;
              }
            }
            // set cardinality depends on depender item
            if (item.selected && item.customerViewable) {
              if (
                item.relationShips &&
                item.relationShips.dependsOn &&
                item.relationShips.dependsOn.length > 0
              ) {
                var dependencies = item.relationShips.dependsOn;
                if (dependencies.length === 1) {
                  if (dependencies[0].cardinality.type === "Exact") {
                    item.isExact = true;
                  } else {
                    var parentItem = qoutedSelectedComponents.findIndex(
                      (x) => x.id === dependencies[0].depender,
                    );
                    item.maxQuantity =
                      dependencies[0].cardinality.range.max *
                      qoutedSelectedComponents[parentItem].quantity;
                    item.isExact = false;
                  }
                  if (dependencies[0].dependencyType === "Mandatory") {
                    item.componentSelected = true;
                  } else {
                    item.componentSelected = false;
                  }
                } else {
                  for (var d = 0; d < dependencies.length; d++) {
                    var pIndex = qoutedSelectedComponents.findIndex(
                      (x) => x.id === dependencies[d].depender,
                    );
                    if (pIndex > -1) {
                      if (dependencies[d].cardinality.type === "Exact") {
                        item.isExact = true;
                      } else {
                        item.maxQuantity =
                          dependencies[d].cardinality.range.max *
                          qoutedSelectedComponents[pIndex].quantity;
                        item.isExact = false;
                      }
                      if (dependencies[d].dependencyType === "Mandatory") {
                        item.componentSelected = true;
                      } else {
                        item.componentSelected = false;
                      }
                      break;
                    }
                  }
                }
              }
            }
          }
          if (
            this.state.hideAutoSelectedProducts &&
            item.relationShips &&
            item.relationShips.dependsOn &&
            item.relationShips.dependsOn.length > 0
          ) {
            const mandatoryDependencies = item.relationShips.dependsOn.filter(
              dep =>
                dep.dependencyType === "Mandatory" &&
                dep.cardinality.type === "Exact"
            );
            if (mandatoryDependencies.length > 0) {
              item.customerViewable = false;
            }
          }

          // if(dependencies[0].depender !== this.state.id && this.state.hideAutoSelectedProducts){
          //                 item.showMandatoryProductItem = false;
          //               }
          if (item.defaultSelected) {
          } else {
            if (selectionType[item.componentType]) {
              item.isCoreItem = true;
              item.trulyCoreItem = true;
            } else {
              item.isCoreItem = false;
              item.trulyCoreItem = false;
            }
          }
          componentData.push(item);
          if (item.customerViewable) {
            componentCount = componentCount + 1;
          }
          return false;
        } else return true;
      });
      if (componentCount > 0) {
        steps.push({
          name: key.id,
          label: key.displayNamePlural ? key.displayNamePlural : key.name,
        });
        revisedComponentTypeList.push(key);
      }
    });
    sortedComponentList = revisedComponentTypeList;
    // set data
    let bread = [];
    if (this.props.router.location.pathname.includes("newOrder")) {
      bread.push(
        { title: "Solutions", url: "/newOrder" },
        {
          title: `${productData.basicDetail.productName}`,
          url: `/newOrder/${id}`,
        },
      );
    } else {
      bread.push(
        { title: "Solutions", url: "/product" },
        {
          title: `${productData.basicDetail.productName}`,
          url: `/product/${id}`,
        },
      );
    }
    // Calculate Starting Price
    let newStartingPrice = productData.basicDetail.startingPrice;
    // let filteredVariants = res.variants.filter(({ features }) => features.includes());
    // filteredVariants && filteredVariants.length > 0 ? newStartingPrice = filteredVariants[0].price.recurringPrice.price : newStartingPrice = res.startingPrice;

    //create list of the available Aux products.
    BusApiCall("GET", `${constants.busV4Url}/catalog/allComponentTypes`)
      .then((res) => {
        let data = res.data;
        let cData = JSON.parse(data.jsonResponse);
        if (cData.globalProducts.length > 0) {
          var count = 0;
          for (var i = 0; i < cData.globalProducts.length; i++) {
            BusApiCall(
              "GET",
              `${constants.busV4Url}/catalogs/products?componentType=${cData.globalProducts[i].id}&mode=pmui`,
            )
              .then((response) => {
                auxiliaryProductsArray.push(...response.data);
                this.setState({ auxiliaryProducts: auxiliaryProductsArray });
                count++;
                if (cData.globalProducts.length === count) {
                  // if (auxiliaryProductsArray.length > 0) {
                  //     //add Auxiliary pdts at the end.
                  //     steps.push({
                  //         id: "PROD_COMP_AUX",
                  //         name: "Auxilary",
                  //         label: "Auxilary",
                  //         iconName: "Auxilary",
                  //         sequenceNum: 9999
                  //     })
                  //     sortedComponentList.push({
                  //         id: "PROD_COMP_AUX",
                  //         name: "Auxilary",
                  //         label: "Auxilary",
                  //         iconName: "Auxilary",
                  //         sequenceNum: 9999
                  //     })
                  // }

                  this.setState(
                    {
                      bread,
                      steps,
                      stepsCopy: steps,
                      images: [
                        productData.basicDetail.productMainImage,
                        productData.basicDetail.productAdditionalImage1,
                        productData.basicDetail.productAdditionalImage2,
                        productData.basicDetail.productAdditionalImage3,
                        productData.basicDetail.productAdditionalImage4,
                      ],
                      description: productData.basicDetail.productDescription,
                      renderView: true,
                      overView: productData.basicDetail.productOverview,
                      techSpecs: productData.basicDetail.productTechSpecs,
                      whatsIncluded:
                        productData.basicDetail.productWhatsIncluded,
                      id: productId,
                      name: productData.basicDetail.productName,
                      startingPrice: newStartingPrice,
                      overrideStartingPrice:
                        productData.basicDetail.overrideStartingPrice,
                      sortedComponentList,
                      componentData,
                      basicDetail: productData.basicDetail,
                      selectionType: selectionType,
                      selectionTypeMinLimit: selectionTypeMinLimit,
                      selectionTypeMaxLimit: selectionTypeMaxLimit,
                      // showAuxiliaryBucket: auxiliaryProductsArray.length > 0 ? true : false
                    },
                    () => {
                      if (
                        this.state.quotedData &&
                        this.state.quotedData.productQuoted &&
                        this.state.quotedData.productQuoted.id
                      ) {
                        if (steps.length > 2) {
                          this.setState(
                            {
                              activeStep: steps.length - 2,
                              showSteps: true,
                            },
                            () => {
                              this.goNext();
                            },
                          );
                        } else {
                          if (steps.length === 2) {
                            this.setState(
                              {
                                activeStep: 0,
                                showSteps: true,
                              },
                              () => {
                                this.goNext();
                              },
                            );
                          } else {
                            this.setState({
                              showSteps: true,
                            });
                          }
                        }
                      }
                      for (var i = 0; i < componentData.length; i++) {
                        if (componentData[i].defaultSelected) {
                          this.selectDependentItems(componentData[i], true);
                        }
                      }
                    },
                  );

                  this.setState({ loading: false });
                }
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({ loading: false });
              });
          }
        } else {
          this.setState(
            {
              bread,
              steps,
              stepsCopy: steps,
              images: [
                productData.basicDetail.productMainImage,
                productData.basicDetail.productAdditionalImage1,
                productData.basicDetail.productAdditionalImage2,
                productData.basicDetail.productAdditionalImage3,
                productData.basicDetail.productAdditionalImage4,
              ],
              description: productData.basicDetail.productDescription,
              renderView: true,
              overView: productData.basicDetail.productOverview,
              techSpecs: productData.basicDetail.productTechSpecs,
              whatsIncluded: productData.basicDetail.productWhatsIncluded,
              id: productId,
              name: productData.basicDetail.productName,
              startingPrice: newStartingPrice,
              overrideStartingPrice:
                productData.basicDetail.overrideStartingPrice,
              sortedComponentList,
              componentData,
              basicDetail: productData.basicDetail,
              selectionType: selectionType,
              showAuxiliaryBucket: false,
              selectionTypeMinLimit: selectionTypeMinLimit,
              selectionTypeMaxLimit: selectionTypeMaxLimit,
            },
            () => {
              if (
                this.state.quotedData &&
                this.state.quotedData.productQuoted &&
                this.state.quotedData.productQuoted.id
              ) {
                if (steps.length > 2) {
                  this.setState(
                    {
                      activeStep: steps.length - 2,
                      showSteps: true,
                    },
                    () => {
                      this.goNext();
                    },
                  );
                } else {
                  if (steps.length === 2) {
                    this.setState(
                      {
                        activeStep: 0,
                        showSteps: true,
                      },
                      () => {
                        this.goNext();
                      },
                    );
                  } else {
                    this.setState({
                      showSteps: true,
                    });
                  }
                }
              }
              for (var i = 0; i < componentData.length; i++) {
                if (componentData[i].defaultSelected) {
                  this.selectDependentItems(componentData[i], true);
                }
              }
            },
          );

          this.setState({ loading: false });
        }
      })
      .catch((err) => {
        {
          !this.props.publicBrowsing &&
            this.props.setErrorMessage(
              this.props.t("NO_COMPONENT_TYPE_FOUND"),
              false,
            );
        }
        this.setState(
          {
            bread,
            steps,
            stepsCopy: steps,
            images: [
              productData.basicDetail.productMainImage,
              productData.basicDetail.productAdditionalImage1,
              productData.basicDetail.productAdditionalImage2,
              productData.basicDetail.productAdditionalImage3,
              productData.basicDetail.productAdditionalImage4,
            ],
            description: productData.basicDetail.productDescription,
            renderView: true,
            overView: productData.basicDetail.productOverview,
            techSpecs: productData.basicDetail.productTechSpecs,
            whatsIncluded: productData.basicDetail.productWhatsIncluded,
            id: productId,
            name: productData.basicDetail.productName,
            startingPrice: newStartingPrice,
            overrideStartingPrice:
              productData.basicDetail.overrideStartingPrice,
            sortedComponentList,
            componentData,
            basicDetail: productData.basicDetail,
            selectionType: selectionType,
            showAuxiliaryBucket: false,
            selectionTypeMinLimit: selectionTypeMinLimit,
            selectionTypeMaxLimit: selectionTypeMaxLimit,
          },
          () => {
            for (var i = 0; i < componentData.length; i++) {
              if (componentData[i].defaultSelected) {
                this.selectDependentItems(componentData[i], true);
              }
            }
          },
        );

        this.setState({ loading: false });
      });
  };

  selectedAuxiliaryProduct = (e, value) => {
    let task = "started";
    for (var i = 0; i < value.length; i++) {
      value[i].quantity = 1;
      value[i].selected = true;
      value[i].isAuxillary = true;
      if (value.length - 1 == i) {
        task = "completed";
      }
    }
    if (task == "completed") {
      this.setState(
        {
          selectedAuxiliaryProducts: [...value],
        },
        () => { },
      );
    }
  };

  setTempPrice = (price, priceType) => {
    if (typeof price === "object") {
      return price;
    } else {
      let pr = {};
      if (priceType === "RC") {
        pr.recurringPrice = {
          termUomId: null,
          price: price,
        };
      }
      pr.purchasePrice = price;
      return pr;
    }
  };

  showSteps = () => {
    this.setState(
      {
        showSteps: true,
      },
      () => {
        this.emptyBucketCheck();
      },
    );
  };

  goNext = () => {
    if (this.state.quantityValidationAttr && this.state.quantityValidationAttr.attrValue) {
      var val = this.validateQuantityRules(this.state.quantityValidationAttr, this.state.componentData);
      if (val) { } else {
        // this.props.setErrorMessage(this.props.t('QUANTITY_VALIDATION_ERROR'), false);
        return;
      }
    }
    // check for required items
    let componentData = [...this.state.componentData];
    let currentBucket = this.state.sortedComponentList[this.state.activeStep];
    let selectedBucketItems = jp.query(
      componentData,
      '$..[?(@.componentType ==="' + currentBucket.id + '")]',
    );

    let selectionType = this.state.selectionType[currentBucket.id];
    if (selectionType) {
      if (selectionType === "SINGLE" || selectionType === "MULTIPLE") {
        if (selectedBucketItems.some((e) => e.selected)) {
          // Do something if selected item found
        } else {
          // this.props.setErrorMessage(currentBucket.name + " is required.", true);
          this.props.setErrorMessage(
            this.props.t("BUCKET_IS_REQUIRED", { currentBucket }),
            false,
          );
          return;
        }
      } else if (selectionType === "LIMIT") {
        const minLimit = this.state.selectionTypeMinLimit[currentBucket.id] || 0;
        const maxLimit = this.state.selectionTypeMaxLimit[currentBucket.id] || Infinity;
        const selectedCount = selectedBucketItems.filter(e => e.selected).length;

        if (selectedCount < minLimit) {
          this.props.setErrorMessage(
            `Minimum ${minLimit} ${currentBucket.name}(s) required.`,
            false
          );
          return;
        }

        if (selectedCount > maxLimit) {
          this.props.setErrorMessage(
            `Maximum ${maxLimit} ${currentBucket.name}(s) allowed.`,
            false
          );
          return;
        }
      } else if (selectionType === "ALL") {
        let count = 0;
        for (var i = 0; i < selectedBucketItems.length; i++) {
          if (selectedBucketItems[i].relationShips) {
            if (this.isDependerSelected(selectedBucketItems[i])) {
              count++;
            }
          } else {
            count++;
          }
        }
        const selectedItemsList = selectedBucketItems
          .filter((a) => a.selected)
          .map((ele) => ele.id);
        if (selectedItemsList.length === count) {
          // All items selected
        } else {
          this.props.setErrorMessage(
            "All " + currentBucket.name + "(s) are required.",
            false,
          );
          return;
        }
      }
    }

    let nextStep = this.state.activeStep + 1;
    let nextActiveStep = nextStep;
    for (
      let i = nextActiveStep;
      i < this.state.sortedComponentList.length;
      i++
    ) {
      if (this.isEmptyStep(i)) {
      } else {
        nextActiveStep = i;
        break;
      }
    }
    this.setState(
      {
        activeStep: nextActiveStep,
      },
      () => {
        this.allItemsRequired();
        this.emptyBucketCheck();
      },
    );
  };

  allItemsRequired = () => {
    let components = this.state.sortedComponentList;
    let tempComponentData = [...this.state.componentData];
    let selectionType = { ...this.state.selectionType };

    let activeBucket = components[this.state.activeStep];
    let selection = selectionType[activeBucket.id];
    if (selection === "ALL") {
      for (var i = 0; i < tempComponentData.length; i++) {
        if (tempComponentData[i].componentType === activeBucket.id) {
          if (tempComponentData[i].relationShips) {
            if (this.isDependerSelected(tempComponentData[i])) {
              // Only auto-select if dependency is Mandatory
              const isMandatory = tempComponentData[i].relationShips.dependsOn?.some(
                dep => {
                  const dependerSelected = this.state.componentData.find(
                    c => c.id === dep.depender && c.selected
                  );
                  return dependerSelected && dep.dependencyType === "Mandatory";
                }
              );

              if (isMandatory) {
                tempComponentData[i].selected = true;
                tempComponentData[i].componentSelected = true;
              }
            }
          } else {
            tempComponentData[i].selected = true;
            // if (selection === "ALL") {
            //   for (var i = 0; i < tempComponentData.length; i++) {
            //     if (tempComponentData[i].componentType === activeBucket.id) {
            //       if (tempComponentData[i].relationShips) {
            //         if (this.isDependerSelected(tempComponentData[i])) {
            //           tempComponentData[i].selected = true;
            //           tempComponentData[i].componentSelected = true;
            //         }
            //       } else {
            //         tempComponentData[i].selected = true;
            tempComponentData[i].componentSelected = true;
          }
        }
      }
    }
    this.setState({
      componentData: tempComponentData,
    });
  };

  goBack = () => {
    if (this.state.activeStep === 0) {
      this.setState({
        showSteps: false,
      });
    } else {
      let nextStep = this.state.activeStep - 1;
      let nextActiveStep = nextStep;
      for (let i = nextActiveStep; i > 0; i--) {
        if (this.isEmptyStep(i)) {
          // if (i === 0) {
          //     nextActiveStep = nextActiveStep - 1;
          // } else {
          //     // Do nothing
          // }
          nextActiveStep = nextActiveStep - 1;
        } else {
          break;
        }
      }
      this.setState(
        {
          activeStep: nextActiveStep,
        },
        () => {
          this.emptyBucketCheck();
        },
      );
    }
  };

  goBackToTab = (tabIndex) => {
    // if (this.state.activeStep === 0) {
    //     this.setState({
    //         showSteps: false,
    //     });
    // } else {
    let nextStep = tabIndex;
    let nextActiveStep = nextStep;
    for (let i = nextActiveStep; i > 0; i--) {
      if (this.isEmptyStep(i)) {
        // if (i === 0) {
        //     nextActiveStep = nextActiveStep - 1;
        // } else {
        //     // Do nothing
        // }
        nextActiveStep = nextActiveStep - 1;
      } else {
        break;
      }
    }
    this.setState(
      {
        activeStep: nextActiveStep,
      },
      () => {
        this.emptyBucketCheck();
      },
    );
    // }
  };

  resetWizard = () => {
    this.changeQuantity(1);
    let componentData = [...this.state.componentData];
    for (var i = 0; i < componentData.length; i++) {
      if (!componentData[i].defaultSelected) {
        //for non-defalut selected items
        componentData[i].selected = false;
        componentData[i].componentSelected = false;
        componentData[i].quantity = 1;
        if (componentData[i].variants && componentData[i].variants.length > 0) {
          componentData[i].variants.forEach((item) => {
            item.selected = false;
          });
        }
      } else {
        //for default selected items, keep them selected but reset quantity
        if (componentData[i].relationShips?.dependsOn) {
          // Reset to calculated default quantity for dependees
          const dep = componentData[i].relationShips.dependsOn[0];
          const dependerQty = 1; // Main product quantity after reset
          const calculated = this.calculateDependeeQuantity(dep, dependerQty);
          componentData[i].quantity = calculated.quantity || 1;
          componentData[i].maxQuantity = calculated.maxQuantity;
        } else {
          // Reset to default quantity (usually 1)
          componentData[i].quantity = 1;
        }
      }
    }
    this.setState({
      componentData,
      activeStep: 0,
      availableItemCount: 1,
      openResetConfirmDialog: false,
    });
  };

  updateComponentSelection = (item) => {
    if (
      this.state.subsciptionData &&
      this.state.subsciptionData.mode === "ChangeSubscription"
    ) {
      if (this.state.subsciptionData.productId) {
        if (this.state.subsciptionData.productId === item.id) {
          this.props.setErrorMessage(this.props.t("SAME_ITEM_SELECTION_ERROR"));
          return;
        }
      }
    }
    this.props.setErrorMessage("", true);
    let selectionType = { ...this.state.selectionType };
    let componentData = [...this.state.componentData];
    const index = componentData.findIndex((a) => a.id === item.id);

    // If selection type is singleton for bucket
    if (selectionType[item.componentType] === "SINGLE") {
      for (let i = 0; i < componentData.length; i++) {
        if (componentData[i].componentType === item.componentType) {
          if (!componentData[i].defaultSelected) {
            if (componentData[i].selected) {
              componentData[i].selected = false;
              componentData[i].showChar = false;
              this.deselectNextBucketItems(
                componentData[i],
                null,
                item.trulyCoreItem ? true : false,
              );
              if (
                componentData[i].variants &&
                componentData[i].variants.length > 0
              ) {
                for (let v = 0; v < componentData[i].variants.length; v++) {
                  componentData[i].variants[v].selected = false;
                }
              }
            }
          }
        }
      }
    }
    if (selectionType[item.componentType] === "LIMIT") {
      const maxLimit = this.state.selectionTypeMaxLimit[item.componentType] || Infinity;
      const minLimit = this.state.selectionTypeMinLimit[item.componentType] || 0;
      const currentlySelected = componentData.filter(
        c => c.componentType === item.componentType && c.selected
      ).length;

      // Prevent selection if already at max (and trying to select, not deselect)
      if (!componentData[index].selected && currentlySelected >= maxLimit) {
        this.props.setErrorMessage(
          `Maximum ${maxLimit} item(s) allowed for ${item.componentTypeName}(s)`,
          false
        );
        return; // Block the selection
      }
      // Prevent deselection if already at min (and trying to deselect)
      if (componentData[index].selected && currentlySelected <= minLimit) {
        this.props.setErrorMessage(
          `Minimum ${minLimit} item(s) required for ${item.componentTypeName}(s)`,
          false
        );
        return; // Block the deselection
      }
    }
    // If there are variants inside assembly
    if (item.children && item.children.length > 0) {
      item.children.forEach(function iter(a) {
        if (a.variants && a.variants.length > 0) {
          item.selectedVariant = componentData[index].selected
            ? ""
            : a.variants[0].productId;
        }
        Array.isArray(a.children) && a.children.forEach(iter);
      });
    }
    if (componentData[index].selected) {
      // console.log('first check')
      componentData[index].selected = false;
      componentData[index].showChar = false;

      const hasDependency = componentData[index].relationShips?.dependsOn;
      const isOptionalWithoutQuantity = hasDependency &&
        componentData[index].relationShips.dependsOn.some(dep => dep.cardinality.type === null);

      const dependsOnList =
        componentData?.[index]?.relationShips?.dependsOn || [];

      const hasExactCardinality = dependsOnList.some(
        dep => dep?.cardinality?.type === "Exact"
      );

      const hasRangeCardinality = dependsOnList.some(
        dep => dep?.cardinality?.type === "Range"
      );

      if (isOptionalWithoutQuantity && !hasExactCardinality) {
        componentData[index].quantity = 0;
      }
      if (
        componentData[index].variants &&
        componentData[index].variants.length > 0
      ) {
        for (let v = 0; v < componentData[index].variants.length; v++) {
          componentData[index].variants[v].selected = false;
        }
      }
      this.deselectNextBucketItems(
        componentData[index],
        null,
        item.trulyCoreItem ? true : false,
      );
    } else {
      // console.log('second check')
      // Select dependent items
      // if (this.deselectNextBucketItems(componentData[index])) {
      componentData[index].selected = true;

      // Set quantity to minimum 1 when selected (or calculated min for dependencies)
      if (componentData[index].relationShips?.dependsOn) {
        // For dependee items, only recalculate if quantity is 0 or missing
        if (!componentData[index].quantity || componentData[index].quantity === 0) {
          const dep = componentData[index].relationShips.dependsOn[0];
          const depender = componentData.find(c => c.id === dep.depender);
          const dependerQty = depender?.quantity || 1;

          // Use the calculateDependeeQuantity logic
          const calculated = this.calculateDependeeQuantity(dep, dependerQty);
          componentData[index].quantity = Math.max(1, calculated.quantity);
          componentData[index].maxQuantity = calculated.maxQuantity;
        }
      } else if (componentData[index].quantity === 0) {
        // For non-dependent items, set to 1 if currently 0
        componentData[index].quantity = 1;
      }

      if (
        componentData[index].productSpec &&
        componentData[index].productSpec.category
      ) {
        componentData[index].showChar = true;
      }
      this.deselectNextBucketItems(
        null,
        componentData[index],
        item.trulyCoreItem ? true : false,
      );
      // this.selectDependentItems(componentData[index]);
      // }
    }

    this.setState({
      componentData,
      unsaveQuoteChanges: true,
    }, () => {
      this.updatePseudoProductQuantity();
    });
  };

  updateAssemblyVariantsSelection = (id, parentId) => {
    this.props.setErrorMessage("", true);
    let componentData = [...this.state.componentData];
    const index = componentData.findIndex((a) => a.id === parentId);
    if (componentData[index].selected) {
      componentData[index].selectedVariant = id;
      this.setState({
        componentData,
        unsaveQuoteChanges: true,
      });
    }
  };

  // deselect depender components
  deselectNextBucketItems = (item, newitem, coreItem) => {
    if (item) {
      // all components list
      let tempComponentData = [...this.state.componentData];
      // deselect depended items
      for (var i = 0; i < tempComponentData.length; i++) {
        // Check for components with dependencies
        if (
          tempComponentData[i].relationShips &&
          tempComponentData[i].relationShips.dependsOn
        ) {
          let dependsOn = tempComponentData[i].relationShips.dependsOn;
          // If components have only one dependency
          if (dependsOn.length === 1) {
            // If depender id matches with deselected component
            if (dependsOn[0].depender === item.id) {
              // If component is default selected then don't do anything
              if (!tempComponentData[i].defaultSelected) {
                // Deselect component and next components depended on it
                tempComponentData[i].selected = false;
                tempComponentData[i].showChar = false;
                this.deselectNextBucketItems(tempComponentData[i]);
                // Deselect component variants
                if (
                  tempComponentData[i].variants &&
                  tempComponentData[i].variants.length > 0
                ) {
                  for (
                    var v = 0;
                    v < tempComponentData[i].variants.length;
                    v++
                  ) {
                    tempComponentData[i].variants[v].selected = false;
                  }
                }
              }
            }
          }
          // new code
          else {
            for (var k = 0; k < dependsOn.length; k++) {
              if (dependsOn[k].depender === item.id) {
                // If component is default selected then don't do anything
                if (!tempComponentData[i].defaultSelected) {
                  // Deselect component and next components depended on it
                  tempComponentData[i].selected = false;
                  tempComponentData[i].showChar = false;
                  this.deselectNextBucketItems(tempComponentData[i]);
                  // Deselect component variants
                  if (
                    tempComponentData[i].variants &&
                    tempComponentData[i].variants.length > 0
                  ) {
                    for (
                      var v = 0;
                      v < tempComponentData[i].variants.length;
                      v++
                    ) {
                      tempComponentData[i].variants[v].selected = false;
                    }
                  }
                }
              }
            }
          }

          // OLD CODE
          // else {
          //     // Since our component is depended on multiple components then
          //     // We have to check that if other depender is selected or not - if selected then add into selectedCount
          //     let selectedCount = null;
          //     let deselectedDependerIndex = null;
          //     for (var j = 0; j < dependsOn.length; j++) {
          //         if (dependsOn[j].depender !== item.id) {
          //             // if other depender is selected then add into selectedCount
          //             let tempIndex = tempComponentData.findIndex(obj => obj.id === dependsOn[j].depender);
          //             if (tempComponentData[tempIndex].selected) {
          //                 selectedCount++;
          //             }
          //         } else {
          //             deselectedDependerIndex = dependsOn[j].depender;
          //         }
          //         // if (dependsOn[j].depender === item.id) {
          //         //     if (!tempComponentData[i].defaultSelected) {
          //         //         tempComponentData[i].selected = false;
          //         //         this.deselectNextBucketItems(tempComponentData[i]);
          //         //         if (tempComponentData[i].variants && tempComponentData[i].variants.length > 0) {
          //         //             for (var v = 0; v < tempComponentData[i].variants.length; v++) {
          //         //                 tempComponentData[i].variants[v].selected = false;
          //         //             }
          //         //         }
          //         //     }
          //         // }
          //     }
          //     if (selectedCount === 0) {
          //         if (tempComponentData[i].id) {
          //             if (!tempComponentData[i].defaultSelected) {
          //                 tempComponentData[i].selected = false;
          //                 this.deselectNextBucketItems(tempComponentData[i]);
          //                 if (tempComponentData[i].variants && tempComponentData[i].variants.length > 0) {
          //                     for (var v = 0; v < tempComponentData[i].variants.length; v++) {
          //                         tempComponentData[i].variants[v].selected = false;
          //                     }
          //                 }
          //             }
          //         }
          //     }
          // }
        }
      }
      // this.setState({
      //     componentData: tempComponentData
      // })
      if (newitem) {
        this.selectDependentItems(newitem, coreItem);
      }
    } else {
      if (newitem) {
        this.selectDependentItems(newitem, coreItem);
      }
    }
  };

  updateComponentVariantSelection = (item, variant) => {
    this.props.setErrorMessage("", true);
    let selectionType = { ...this.state.selectionType };
    let componentData = [...this.state.componentData];
    const index = componentData.findIndex((a) => a.id === item.id);

    // If selection type is singleton for bucket
    if (selectionType[item.componentType] === "SINGLE") {
      for (let i = 0; i < componentData.length; i++) {
        if (componentData[i].componentType === item.componentType) {
          if (!componentData[i].defaultSelected) {
            componentData[i].selected = false;
            if (
              componentData[i].variants &&
              componentData[i].variants.length > 0
            ) {
              for (let v = 0; v < componentData[i].variants.length; v++) {
                componentData[i].variants[v].selected = false;
              }
            }
          }
        }
      }
    }

    if (selectionType[item.componentType] === "LIMIT") {
      const maxLimit = this.state.selectionTypeMaxLimit[item.componentType] || Infinity;
      const currentlySelected = componentData.filter(
        c => c.componentType === item.componentType && c.selected
      ).length;

      // Prevent selection if already at max (and trying to select, not deselect)
      if (!componentData[index].selected && currentlySelected >= maxLimit) {
        this.props.setErrorMessage(
          `Maximum ${maxLimit} item(s) allowed for ${item.componentType}`,
          false
        );
        return; // Block the selection
      }
    }
    componentData[index].selected = true;
    // check if depender selected
    var dependerSelected = false;
    var dependers = componentData[index].relationShips;
    if (dependers && dependers.dependsOn && dependers.dependsOn.length > 0) {
      for (var i = 0; i < dependers.dependsOn.length; i++) {
        var ci = componentData.findIndex(
          (a) => a.id === dependers.dependsOn[i].depender,
        );
        if (
          index > -1 &&
          dependers.dependsOn[i].dependencyType === "Mandatory"
        ) {
          dependerSelected = true;
        }
      }
    }
    // Select item
    if (
      componentData[index].variants &&
      componentData[index].variants.length > 0
    ) {
      for (let v = 0; v < componentData[index].variants.length; v++) {
        if (componentData[index].variants[v].id === variant) {
          if (componentData[index].variants[v].selected) {
            if (dependerSelected) {
            } else {
              componentData[index].selected = false;
              componentData[index].variants[v].selected = false;
            }
          } else {
            componentData[index].variants[v].selected = true;
          }
        } else {
          componentData[index].variants[v].selected = false;
        }
      }
    }

    // Select dependent items
    let dependerItemData = {};
    dependerItemData.id = variant;
    dependerItemData.quantity = componentData[index].quantity;
    this.selectDependentItems(dependerItemData);

    this.setState({
      componentData,
      unsaveQuoteChanges: true,
    });
  };

  // Recursive method to select depended items
  selectDependentItems = (item, coreItem) => {
    let tempComponentData = [...this.state.componentData];
    // check items depended on solution plans
    for (var i = 0; i < tempComponentData.length; i++) {
      if (
        tempComponentData[i].relationShips &&
        tempComponentData[i].relationShips.dependsOn
      ) {
        let dependsOn = tempComponentData[i].relationShips.dependsOn;
        var matchingDep = null;
        if (item.variants && item.variants.length > 0) {
          var vIndex = item.variants.findIndex((a) => a.selected);
          if (vIndex > -1) {
            matchingDep = this.findMatchingDependency(dependsOn, item.quantity, item.variants[vIndex].id);
          }
        } else {
          matchingDep = this.findMatchingDependency(dependsOn, item.quantity, item.id);
        }

        // const matchingDep = this.findMatchingDependency(dependsOn, item.quantity, item.id);
        if (matchingDep) {
          const calculated = this.calculateDependeeQuantity(matchingDep, item.quantity);
          // console.log('calculated', calculated, item.quantity, matchingDep);
          // if (dependsOn[j].depender === item.id) {
          if (matchingDep.cardinality?.type === "Exact") {
            if (calculated.quantity > 0) {
              tempComponentData[i].isExact = true;
              tempComponentData[i].quantity = calculated.quantity;
              // if (
              //   dependsOn[j].cardinality.range.min !== 0 &&
              //   dependsOn[j].cardinality.range.max !== 0
              // ) {
              //   tempComponentData[i].isExact = true;
              //   tempComponentData[i].quantity =
              //     dependsOn[j].cardinality.range.min * item.quantity;
            } else {
              tempComponentData[i].quantity = 0;
              tempComponentData[i].isExact = true;
            }
          } else {
            tempComponentData[i].quantity = calculated.quantity || 1;
            tempComponentData[i].maxQuantity = calculated.maxQuantity;
            tempComponentData[i].isExact = false;
            // tempComponentData[i].quantity =
            //   dependsOn[j].cardinality.range.min === 0
            //     ? 1
            //     : dependsOn[j].cardinality.range.min;
            // tempComponentData[i].maxQuantity =
            //   dependsOn[j].cardinality.range.max * item.quantity;
            // tempComponentData[i].isExact = false;
          }
          if (matchingDep.dependencyType === "Mandatory") {
            if (calculated.quantity > 0) {
              tempComponentData[i].selected = true;
            } else {
              tempComponentData[i].selected = false;
            }
            if (
              tempComponentData[i].productSpec &&
              tempComponentData[i].productSpec.category
            ) {
              if (tempComponentData[i].showChar) {
                tempComponentData[i].showChar = true;
              } else {
                tempComponentData[i].showChar = true;
              }
            }
            if (coreItem) {
              tempComponentData[i].isCoreItem = true;
            }
            tempComponentData[i].componentSelected = true;
            if (
              tempComponentData[i].variants &&
              tempComponentData[i].variants.length > 0
            ) {
              tempComponentData[i].variants[0].selected = true;
            }
            this.setState({
              componentData: tempComponentData,
            });
            // if (
            //   tempComponentData[i].variants &&
            //   tempComponentData[i].variants.length > 0
            // ) {
            //   this.selectDependentItems(tempComponentData[i].variants[0], coreItem);
            // } else {
            //   this.selectDependentItems(tempComponentData[i], coreItem);
            // }
            this.selectDependentItems(tempComponentData[i], coreItem);
          } else {
            tempComponentData[i].quantity =
              matchingDep.cardinality.range.min === 0
                ? 1
                : matchingDep.cardinality.range.min;
            tempComponentData[i].maxQuantity =
              matchingDep.cardinality.range.max * item.quantity;
            tempComponentData[i].componentSelected = false;
            tempComponentData[i].showChar = false;
          }
          // }
        } else {
          // No matching dependency - deselect if it was dependent on this item
          const wasDependentOnThisItem = dependsOn.some(dep => dep.depender === item.id);
          if (wasDependentOnThisItem) {
            tempComponentData[i].selected = false;
            tempComponentData[i].componentSelected = false;
          }
        }
      }
    }
    this.setState({
      componentData: tempComponentData,
    });
  };

  isDependerSelected = (data) => {
    if (data.relationShips && data.relationShips.dependsOn) {
      let dependersIds = jp.query(data.relationShips.dependsOn, "$..depender");
      let selectedIds = jp.query(
        this.state.componentData,
        "$..[?(@.selected)].id",
      );
      for (var i = 0; i < dependersIds.length; i++) {
        if (dependersIds.includes(this.state.id)) {
          return true;
        }
        if (selectedIds.includes(dependersIds[i])) {
          return true;
        }
        if (i + 1 === dependersIds.length) {
          return false;
        }
      }
    } else {
      return true;
    }
  };
  // Change packaged solution quantity
  changeQuantity = (value) => {
    if (value === '' || /^[0-9]*\.?[0-9]*$/.test(value)) {
      let componentData = [...this.state.componentData];
      this.setState({
        quantity: value,
        componentData,
        unsaveQuoteChanges: true,
      });
    }
  };

  validateOfferingQuantity = () => {
    var trimmed = '';
    if (this.state.quantity) {
      trimmed = this.state.quantity.trim();
    }

    // Convert to number if possible
    const numericValue = Number(trimmed);

    // If empty, spaces only, NaN, or 0/0.00, fallback to 1
    if (
      trimmed === '' ||
      isNaN(numericValue) ||
      numericValue === 0
    ) {
      this.setState({
        quantity: '1',
      })
    } else {
      this.setState({
        quantity: numericValue.toString()
      })
    }
  }

  changeComponentQuantity = (id, value) => {
    if (value > 0) {
      let componentData = [...this.state.componentData];
      let index = componentData.findIndex((a) => a.id === id);
      componentData[index].quantity = value;

      this.setState(
        {
          componentData,
          unsaveQuoteChanges: true,
        },
        () => {
          this.changeDependedComponentsQuantity(componentData[index]);
          this.updatePseudoProductQuantity();
        },
      );
    }
  };

  setShowChar = (item) => {
    let componentData = [...this.state.componentData];
    let index = componentData.findIndex((a) => a.id === item.id);
    if (
      componentData[index].productSpec &&
      componentData[index].productSpec.category
    ) {
      if (componentData[index].showChar) {
        componentData[index].showChar = false;
      } else {
        componentData[index].showChar = true;
      }
    }

    this.setState(
      {
        componentData,
        unsaveQuoteChanges: true,
      },
      () => {
        this.changeDependedComponentsQuantity(componentData[index]);
      },
    );
  };

  calculateAggregatedDependeeQuantity = (dependeeId) => {
    let tempComponentData = [...this.state.componentData];
    let totalQuantity = 0;
    let totalMaxQuantity = 0;
    let isExact = false;
    let hasDependencies = false;

    // Find all selected dependers that depend on this dependee
    tempComponentData.forEach((depender) => {
      if (!depender.selected) return; // Skip unselected items

      // Check if this depender has the dependee in its dependencies
      const dependeeIndex = tempComponentData.findIndex(d => d.id === dependeeId);
      if (dependeeIndex === -1) return;

      const dependee = tempComponentData[dependeeIndex];
      if (!dependee.relationShips || !dependee.relationShips.dependsOn) return;

      // Get the depender ID (handle variants)
      let dependerIdToCheck = depender.id;
      if (depender.variants && depender.variants.length > 0) {
        const vIndex = depender.variants.findIndex((v) => v.selected);
        if (vIndex > -1) {
          dependerIdToCheck = depender.variants[vIndex].id;
        }
      }

      // Find if there's a matching dependency
      const matchingDep = this.findMatchingDependency(
        dependee.relationShips.dependsOn,
        depender.quantity,
        dependerIdToCheck
      );

      if (matchingDep) {
        hasDependencies = true;
        const calculated = this.calculateDependeeQuantity(matchingDep, depender.quantity);

        // Sum up quantities from all dependers
        totalQuantity += calculated.quantity;
        totalMaxQuantity += calculated.maxQuantity;

        // If ANY dependency is exact, the result should be exact
        if (calculated.isExact) {
          isExact = true;
        }
      }
    });

    return {
      quantity: totalQuantity,
      maxQuantity: totalMaxQuantity,
      isExact: isExact,
      hasDependencies: hasDependencies
    };
  };

  changeDependedComponentsQuantity = (item) => {
    let tempComponentData = [...this.state.componentData];
    // check items depended on solution plans
    for (var i = 0; i < tempComponentData.length; i++) {
      if (
        tempComponentData[i].relationShips &&
        tempComponentData[i].relationShips.dependsOn
      ) {
        let dependsOn = tempComponentData[i].relationShips.dependsOn;
        var matchingDep = null;
        if (item.variants && item.variants.length > 0) {
          var vIndex = item.variants.findIndex((a) => a.selected);
          if (vIndex > -1) {
            matchingDep = this.findMatchingDependency(dependsOn, item.quantity, item.variants[vIndex].id);
          }
        } else {
          matchingDep = this.findMatchingDependency(dependsOn, item.quantity, item.id);
        }
        // console.log("Processing component:", tempComponentData[i].name, "matchingDep:", matchingDep);
        if (matchingDep) {
          // const calculated = this.calculateDependeeQuantity(matchingDep, item.quantity);
          const aggregated = this.calculateAggregatedDependeeQuantity(tempComponentData[i].id);
          // if (matchingDep.depender === item.id) {
          if (matchingDep.dependencyType === "Mandatory") {
            if (aggregated.quantity > 0) {
              tempComponentData[i].selected = true;
            } else {
              tempComponentData[i].selected = false;
            }
            this.setState({
              componentData: tempComponentData,
            });
            this.changeDependedComponentsQuantity(tempComponentData[i]);
          } else {
            // tempComponentData[i].maxQuantity =
            //   matchingDep.cardinality.range.max * item.quantity;
            tempComponentData[i].maxQuantity = aggregated.maxQuantity;
            tempComponentData[i].selected = false;
          }
          if (aggregated.isExact) {
            // tempComponentData[i].quantity = calculated.quantity;
            tempComponentData[i].quantity = aggregated.quantity;
            tempComponentData[i].isExact = true;
            // tempComponentData[i].quantity =
            //   dependsOn[j].cardinality.range.min * item.quantity;
          } else {
            // tempComponentData[i].maxQuantity = calculated.maxQuantity;
            // tempComponentData[i].quantity = matchingDep.dependencyType === "Mandatory" ? aggregated.quantity : 1;
            tempComponentData[i].quantity = aggregated.quantity;
            tempComponentData[i].maxQuantity = aggregated.maxQuantity;
            tempComponentData[i].isExact = false;
            // tempComponentData[i].maxQuantity =
            //   dependsOn[j].cardinality.range.max * item.quantity;
          }
          // }
        } else {
          // No matching dependency - deselect if it was dependent on this item
          const wasDependentOnThisItem = dependsOn.some(dep => dep.depender === item.id);
          if (wasDependentOnThisItem) {
            tempComponentData[i].selected = false;
            tempComponentData[i].componentSelected = false;
          }
        }
      }
    }
    this.setState({
      componentData: tempComponentData,
    });
  };

  isEmptyStep = (stepCount) => {
    if (stepCount > 0) {
      let selectedComponentType = this.state.sortedComponentList[stepCount].id;
      let displayedComponentCount = 0;
      this.state.componentData.map((item) => {
        if (
          item.componentType === selectedComponentType &&
          (item.defaultSelected || this.isDependerSelected(item)) &&
          item.customerViewable
        ) {
          displayedComponentCount = displayedComponentCount + 1;
        }
      });
      if (displayedComponentCount === 0) {
        return true;
      }
    }
    return false;
  };

  checkForChanges = () => {
    if (this.state.unsaveQuoteChanges) {
      this.setState({
        showChangesWarning: true,
      });
    } else {
      this.props.router.navigate("/quote");
    }
  };

  closeChangesWarning = (val) => {
    if (val) {
      // this.createQuoute();
      this.setState({
        showChangesWarning: false,
      });
    } else {
      this.setState({
        showChangesWarning: false,
        unsaveQuoteChanges: false,
      });
      this.props.router.navigate("/quote");
    }
  };

  createQuoute = () => {
    if (this.state.quantityValidationAttr && this.state.quantityValidationAttr.attrValue) {
      var val = this.validateQuantityRules(this.state.quantityValidationAttr, this.state.componentData);
      if (val) { } else {
        // this.props.setErrorMessage(this.props.t('QUANTITY_VALIDATION_ERROR'), false);
        return;
      }
    }
    // check for required items
    let componentData = [...this.state.componentData];
    if (this.state.selectedAuxiliaryProducts.length > 0) {
      componentData.push(...this.state.selectedAuxiliaryProducts);
    }

    let currentBucket = this.state.sortedComponentList[this.state.activeStep];
    let selectedBucketItems = jp.query(
      componentData,
      '$..[?(@.componentType ==="' + currentBucket.id + '")]',
    );
    let selectionType = this.state.selectionType[currentBucket.id];
    if (selectionType === "SINGLE" || selectionType === "MULTIPLE") {
      if (selectedBucketItems.some((e) => e.selected)) {
        // Do something if selected item found
      } else if (selectionType === "LIMIT") {
        const minLimit = this.state.selectionTypeMinLimit[currentBucket.id] || 0;
        const maxLimit = this.state.selectionTypeMaxLimit[currentBucket.id] || Infinity;
        const selectedCount = selectedBucketItems.filter(e => e.selected).length;

        if (selectedCount < minLimit) {
          this.props.setErrorMessage(
            `Minimum ${minLimit} ${currentBucket.name}(s) required.`,
            false
          );
          return;
        }

        if (selectedCount > maxLimit) {
          this.props.setErrorMessage(
            `Maximum ${maxLimit} ${currentBucket.name}(s) allowed.`,
            false
          );
          return;
        }
      } else {
        this.props.setErrorMessage(currentBucket.name + " is required.", false);
        return;
      }
    } else if (selectionType === "ALL") {
      const selectedItemsList = selectedBucketItems
        .filter((a) => a.selected)
        .map((ele) => ele.id);
      if (selectedBucketItems.length === selectedItemsList.length) {
        // All items selected
      } else {
        this.props.setErrorMessage(
          "All " + currentBucket.displayNamePlural
            ? currentBucket.displayNamePlural
            : currentBucket.name + " required.",
          true,
        );
        return;
      }
    }
    this.setState({ loading: true });

    // Create cart data
    let sol = {
      id: this.state.id,
      name: this.state.basicDetail.productName,
      quantity: this.state.quantity,

      releaseDate: this.state.basicDetail.releaseDate,
      providerId: this.state.providerId,
      originalProviderId: this.state.basicDetail.originalProviderId,
      tenantId: this.props.tenantId,
      selectedPromo: this.state.selectedPromo,
      discount: 0,
    };
    sol.associatedItems = [];
    let tempAssociatedItems = [];
    for (var i = 0; i < componentData.length; i++) {
      if (componentData[i].selected && componentData[i].quantity > 0) {
        if (componentData[i].variants && componentData[i].variants.length > 0) {
          for (var v = 0; v < componentData[i].variants.length; v++) {
            if (componentData[i].variants[v].selected) {
              componentData[i].variants[v].name =
                componentData[i].name +
                " - " +
                componentData[i].variants[v].name;
              componentData[i].variants[v].componentType =
                componentData[i].componentType;
              componentData[i].variants[v].physical = componentData[i].physical;
              componentData[i].variants[v].relationShips =
                componentData[i].relationShips;
              componentData[i].variants[v].quantity = componentData[i].quantity;
              componentData[i].variants[v].customerViewable =
                componentData[i].customerViewable;
              componentData[i].variants[v].price = this.getPriceWithPromo(
                componentData[i].variants[v].price,
                componentData[i].variants[v].id,
                componentData[i].variants[v].priceType,
              );
              componentData[i].variants[v].isCoreItem = componentData[i]
                .isCoreItem
                ? componentData[i].isCoreItem
                : false;
              tempAssociatedItems.push(componentData[i].variants[v]);
            }
          }
        } else {
          componentData[i].price = this.getPriceWithPromo(
            componentData[i].price,
            componentData[i].id,
            componentData[i].priceType,
          );
          tempAssociatedItems.push(componentData[i]);
        }
      }
    }

    let sortedComponentList = this.state.componentTypeList.sort((a, b) =>
      a.sequenceNum > b.sequenceNum
        ? 1
        : b.sequenceNum > a.sequenceNum
          ? -1
          : 0,
    );
    sortedComponentList.forEach((key, index) => {
      tempAssociatedItems.filter((item) => {
        if (item.componentType === key.id) {
          sol.associatedItems.push(item);
        }
      });
    });
    // this.props.addToCart(sol, []);
    // this.props.router.navigate("/cart");

    // new cart code
    var newCartData = {};
    newCartData.quoteItem = [];
    if (this.props.publicBrowsing) {
      newCartData.relatedParty = [];
    } else if (
      this.state.isSubscriptionMode &&
      this.state.subsciptionData.mode !== "NewActivation"
    ) {
      newCartData.relatedParty = [
        {
          id: this.state.subsciptionData.ban,
          partyId: this.state.subsciptionData.partyId,
          firstName: this.state.subsciptionData.firstName,
          lastName: this.state.subsciptionData.lastName,
          role: this.state.subsciptionData.role
            ? this.state.subsciptionData.role
            : "Customer",
        },
      ];
      newCartData.type = this.props.router.location.state.subsciptionData.mode;

      if (
        this.state.subsciptionData &&
        (this.state.subsciptionData.mode === "ChangeSubscription" ||
          this.state.subsciptionData.mode === "NewAddon") &&
        !this.state.subsciptionData.oldQuote
      ) {
        if (this.state.subsciptionData.mode === "ChangeSubscription") {
          if (this.state.subsciptionData.isAddon) {
            newCartData.note = [
              {
                text:
                  "Change of add-on " +
                  this.state.subsciptionData.subscriptionId +
                  " associated with order number " +
                  this.state.subsciptionData.orderId,
              },
            ];
          } else {
            newCartData.note = [
              {
                // text: `Change of subscription ${this.state.subsciptionData.name} (Subscription Id: ${this.state.subsciptionData.subscriptionId}) associated with order number ${this.state.subsciptionData.orderId}`
                text: (() => {
                  let paramString = "";
                  if (this.state.subsciptionData.additionalAttributes) {
                    const paramsAttr =
                      this.state.subsciptionData.additionalAttributes.find(
                        (attr) => attr.namedType === "params",
                      );
                    if (paramsAttr && paramsAttr.namedId) {
                      const params = JSON.parse(paramsAttr.namedId);
                      paramString = params
                        .map((p) => `${p.label}: ${p.value}`)
                        .join(", ");
                    }
                  }
                  return `Change of the ${this.state.subsciptionData.productName} subscription (Subscription ID: ${this.state.subsciptionData.subscriptionId}, ${paramString}) associated with order number ${this.state.subsciptionData.orderId}.`;
                })(),
              },
            ];
          }
        } else if (this.state.subsciptionData.mode === "NewAddon") {
          newCartData.note = [
            {
              // text: (() => {
              //     let paramString = '';
              //     if (this.state.subsciptionData.additionalAttributes) {
              //         const paramsAttr = this.state.subsciptionData.additionalAttributes.find(attr => attr.namedType === 'params');
              //         if (paramsAttr && paramsAttr.namedId) {
              //             const params = JSON.parse(paramsAttr.namedId);
              //             paramString = params.map(p => `${p.label}: ${p.value}`).join(', ');
              //         }
              //     }
              //     return `Change of the ${this.state.subsciptionData.productName} subscription (Subscription ID: ${this.state.subsciptionData.subscriptionId}, ${paramString}) associated with order number ${this.state.subsciptionData.orderId}.`;
              // })()
            },
          ];
        }
      }

      if (this.state.subsciptionData.userData) {
        newCartData.userData = this.state.subsciptionData.userData;
      } else {
        if (this.state.subsciptionData.isAddon) {
          newCartData.userData = [
            {
              name: "assetParentOrderId",
              value: this.state.subsciptionData.orderId,
            },
            {
              name: "assetId",
              value: this.state.subsciptionData.subscriptionId,
            },
            {
              name: "assetPackageIndex",
              value: this.state.subsciptionData.packageIndex,
            },
            {
              name: "addOnOrder",
              value: "Y",
            },
          ];
        } else {
          newCartData.userData = [
            {
              name: "parentOrderId",
              value: this.state.subsciptionData.orderId,
            },
            {
              name: "subscriptionId",
              value: this.state.subsciptionData.subscriptionId,
            },
            {
              name: "packageIndex",
              value: this.state.subsciptionData.packageIndex,
            },
          ];
        }
      }
    } else if (this.state.quotedData && this.state.quotedData.originalQuoteId) {
      newCartData.relatedParty = [
        {
          // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.partyId : '',
          id: this.state.quotedData.quotedCustomer.ban,
          partyId: this.state.quotedData.relatedParty.id,
          firstName: this.state.quotedData.relatedParty.firstName,
          lastName: this.state.quotedData.relatedParty.lastName,
          role:
            this.state.quotedData.relatedParty &&
              this.state.quotedData.relatedParty.role
              ? this.state.quotedData.relatedParty.role
              : "",
        },
      ];
      if (this.state.quotedData.type) {
        newCartData.type = this.state.quotedData.type;
        newCartData.userData = this.state.quotedData.userData;
      }
    } else if (this.state.isLeadQuote) {
      console.log("prepare lead data", this.state.leadData);
      var selectedCustomer = this.state.leadData;
      newCartData.relatedParty = [
        {
          // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.partyId : '',
          id:
            selectedCustomer && selectedCustomer.ban
              ? selectedCustomer.ban
              : "",
          partyId: selectedCustomer.partyId,
          firstName: selectedCustomer.firstName
            ? selectedCustomer.firstName
            : "",
          lastName: selectedCustomer.lastName ? selectedCustomer.lastName : "",
          role:
            selectedCustomer && selectedCustomer.role
              ? selectedCustomer.role
              : "",
        },
      ];
    } else {
      var selectedCustomer = JSON.parse(
        localStorage.getItem("preSelectedCustomer"),
      );
      
      if (selectedCustomer && selectedCustomer.childFirstName) {
        newCartData.relatedParty = [
          {
            // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.partyId : '',
            id:
              selectedCustomer && selectedCustomer.ban
                ? selectedCustomer.ban
                : "",
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.childFirstName,
            lastName: selectedCustomer.childLastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      } else {
        if (selectedCustomer && selectedCustomer.partyId) {
          newCartData.relatedParty = [
            {
              // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.ban : selectedCustomer.partyId,
              id:
                selectedCustomer && selectedCustomer.ban
                  ? selectedCustomer.ban
                  : "",
              partyId: selectedCustomer.partyId,
              firstName: selectedCustomer.firstName,
              lastName: selectedCustomer.lastName,
              role:
                selectedCustomer && selectedCustomer.role
                  ? selectedCustomer.role
                  : "",
            },
          ];
        } else {
          if (
            this.state.subsciptionData &&
            this.state.subsciptionData.partyId
          ) {
            newCartData.relatedParty = [
              {
                // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.ban : selectedCustomer.partyId,
                id:
                  this.state.subsciptionData && this.state.subsciptionData.ban
                    ? this.state.subsciptionData.ban
                    : "",
                partyId: this.state.subsciptionData.partyId,
                firstName: this.state.subsciptionData.firstName,
                lastName: this.state.subsciptionData.lastName,
                role:
                  this.state.subsciptionData && this.state.subsciptionData.role
                    ? this.state.subsciptionData.role
                    : "",
              },
            ];
          }
        }
      }
    }
    var tempPSData = {
      action: "ADD",
      productOffering: {
        id: this.state.id,
        name: this.state.basicDetail.productName,
        quantity: +this.state.quantity,
        includedItems: [],
      },
    };
    if (this.state.selectedPromo && this.state.selectedPromo.id) {
      tempPSData.productOffering.specialPricingCode =
        this.state.selectedPromo.id;
    }

    if (
      this.state.quotedData &&
      this.state.quotedData.productQuoted &&
      this.state.quotedData.productQuoted.id
    ) {
      tempPSData.action = "MODIFY";
      tempPSData.index = this.state.quotedData.quoteData.quoteIndex;
      tempPSData.id = this.state.quotedData.quoteData.quoteId;
    } else {
      if (
        this.props.shoppingQuote &&
        Array.isArray(this.props.shoppingQuote) &&
        this.props.shoppingQuote.length > 0 &&
        this.props.shoppingQuote[0].cartItem &&
        this.props.shoppingQuote[0].cartItem.length > 0
      ) {
        tempPSData.index =
          this.props.shoppingQuote[0].cartItem[
            this.props.shoppingQuote[0].cartItem.length - 1
          ].index + 1;
      } else {
        tempPSData.index = 0;
      }
    }

    var finalAssociatedItems = [];
    var sortedIAssociatedItems = [];
    for (var i = 0; i < sortedComponentList.length; i++) {
      let bItems = jp.query(
        tempAssociatedItems,
        '$[?(@.componentType=="' + sortedComponentList[i].id + '")]',
      );
      sortedIAssociatedItems = sortedIAssociatedItems.concat(bItems);
      finalAssociatedItems = finalAssociatedItems.concat(bItems);
    }
    for (var j = 0; j < tempAssociatedItems.length; j++) {
      var index = sortedIAssociatedItems.findIndex(
        (a) => a.id === tempAssociatedItems[j].id,
      );
      if (index > -1) {
      } else {
        finalAssociatedItems.push(tempAssociatedItems[j]);
      }
    }

    finalAssociatedItems = finalAssociatedItems.filter(item => item.quantity > 0);
    for (var i = 0; i < finalAssociatedItems.length; i++) {
      var item = {
        id: finalAssociatedItems[i].id,
        // name: finalAssociatedItems[i].name,
        quantity: +finalAssociatedItems[i].quantity,
        // price: finalAssociatedItems[i].price.purchasePrice,
        // priceType: finalAssociatedItems[i].priceTenureUOM ? 'NTC' : finalAssociatedItems[i].priceType,
        isCoreItem: finalAssociatedItems[i].isCoreItem,
      };
      if (finalAssociatedItems[i].priceTenureUOM) {
        // item.priceTenure = finalAssociatedItems[i].priceTenure;
        // item.priceTenureUOM = finalAssociatedItems[i].priceTenureUOM;
      }
      if (
        this.props.router.location.state &&
        this.props.router.location.state.subsciptionData &&
        (this.props.router.location.state.subsciptionData.mode ===
          "ChangeSubscription" ||
          this.props.router.location.state.subsciptionData.mode === "NewAddon")
      ) {
        item.parentOrderId = this.state.subsciptionData.orderId;
        item.parentPackageIndex = this.state.subsciptionData.packageIndex;
        item.parentOrderItemSeqId = this.state.subsciptionData.orderItemSeqId;
        item.parentSubscriptionId = this.state.subsciptionData.subscriptionId;
        item.parentSubscriptionName = this.state.subsciptionData.productName;
      }
      tempPSData.productOffering.includedItems.push(item);
    }
    newCartData.quoteItem.push(tempPSData);
    if (tempPSData.productOffering.includedItems.length === 0) {
      this.setState({ loading: false });
      this.props.setErrorMessage(
        this.props.t("NO_ITEMS_SELECTED_TO_ADD_TO_CART"),
        false,
      );
      return;
    }

    console.log("check final payload", newCartData);
    // return;
    if (this.props.publicBrowsing) {
      sessionStorage.setItem("publicCart", JSON.stringify(newCartData));
      window.localStorage.setItem("doLogin", true);
      window.location.reload();
    } else {
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        newCartData.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      if (
        this.state.isSubscriptionMode &&
        this.state.subsciptionData.mode !== "NewActivation"
      ) {
        if (this.state.subsciptionData.oldQuote) {
          newCartData.action = "EDIT_QUOTE";
          newCartData.discount = this.state.subsciptionData.discountPercentage
            ? this.state.subsciptionData.discountPercentage
            : "";
          if (
            this.props.router.location.state.subsciptionData &&
            this.props.router.location.state.subsciptionData.index
          ) {
            newCartData.quoteItem[0].index =
              this.props.router.location.state.subsciptionData.index;
          }
          BusApiCall(
            "PATCH",
            `${constants.busV44UrlPublic}/quote/${this.props.router.location.state.subsciptionData.id}`,
            newCartData,
          )
            .then((res) => {
              if (res.data.code && res.data.code === "500") {
                this.props.setErrorMessage(res.data.reason, false);
                this.setState({ loading: false });
              } else {
                if (this.state.isSubscriptionMode) {
                  this.props.router.navigate(
                    "/quote/" + this.props.router.location.state.subsciptionData.id,
                  );
                } else {
                  this.props.setQuote(res.data);
                  this.setState({ loading: false });
                  this.props.router.navigate("/quote");
                }
              }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        } else {
          if (
            this.state.oldChangeSubscriptionData &&
            this.state.oldChangeSubscriptionData.id
          ) {
            newCartData.action = "EDIT_QUOTE";
            newCartData.discount = this.state.subsciptionData.discountPercentage
              ? this.state.subsciptionData.discountPercentage
              : "";
            newCartData.userData =
              this.state.oldChangeSubscriptionData.userData;
            for (var i = 0; i < newCartData.userData.length; i++) {
              if (newCartData.userData[i].name === "parentOrderId") {
                newCartData.userData[i].value =
                  newCartData.userData[i].value +
                  "," +
                  this.state.subsciptionData.orderId;
              }
              if (newCartData.userData[i].name === "subscriptionId") {
                newCartData.userData[i].value =
                  newCartData.userData[i].value +
                  "," +
                  this.state.subsciptionData.subscriptionId;
              }
              if (newCartData.userData[i].name === "packageIndex") {
                newCartData.userData[i].value =
                  newCartData.userData[i].value +
                  "," +
                  this.state.subsciptionData.packageIndex;
              }
            }
            if (
              this.state.subsciptionData &&
              this.state.subsciptionData.index
            ) {
              if (
                this.state.oldChangeSubscriptionData.cartItem &&
                this.state.oldChangeSubscriptionData.cartItem.length > 0
              ) {
                newCartData.quoteItem[0].index =
                  this.state.oldChangeSubscriptionData.cartItem[
                    this.state.oldChangeSubscriptionData.cartItem.length - 1
                  ].index;
              } else {
                newCartData.quoteItem[0].index = 0;
              }
            }
            BusApiCall(
              "PATCH",
              `${constants.busV44UrlPublic}/quote/${this.state.oldChangeSubscriptionData.id}`,
              newCartData,
            )
              .then((res) => {
                if (res.data.code && res.data.code === "500") {
                  this.props.setErrorMessage(res.data.reason, false);
                  this.setState({ loading: false });
                } else {
                  if (this.state.isSubscriptionMode) {
                    this.props.router.navigate(
                      "/quote/" + this.state.oldChangeSubscriptionData.id,
                    );
                  } else {
                    this.props.setQuote(res.data);
                    this.setState({ loading: false });
                    this.props.router.navigate("/quote");
                  }
                }
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({
                  loading: false,
                });
              });
          } else {
            newCartData.action = "CREATE_QUOTE";
            BusApiCall(
              "POST",
              `${constants.busV44UrlPublic}/quote`,
              newCartData,
            )
              .then((res) => {
                if (res.data.code && res.data.code === "500") {
                  this.props.setErrorMessage(res.data.reason, false);
                  this.setState({ loading: false });
                } else {
                  if (this.state.isSubscriptionMode) {
                    this.props.router.navigate("/quote/" + res.data.quoteId);
                  } else {
                    this.props.setQuote(res.data);
                    this.setState({ loading: false });
                    this.props.router.navigate("/quote");
                  }
                }
              })
              .catch((err) => {
                if (
                  err.response &&
                  err.response.data &&
                  err.response.data.message
                ) {
                  this.props.setErrorMessage(err.response.data.message, false);
                } else {
                  this.props.setErrorMessage(
                    this.props.t("DEFAULT_ERROR_MESSAGE"),
                    false,
                  );
                }
                this.setState({
                  loading: false,
                });
              });
          }
        }
      } else {
        if (
          this.state.isSubscriptionMode &&
          this.state.subsciptionData.mode === "NewActivation"
        ) {
          newCartData.action = "EDIT_QUOTE";
          newCartData.discount = this.state.subsciptionData.discountPercentage
            ? this.state.subsciptionData.discountPercentage
            : "";
          if (this.props.router.location.state.subsciptionData.index) {
            newCartData.quoteItem[0].index =
              this.props.router.location.state.subsciptionData.index;
          }
          BusApiCall(
            "PATCH",
            `${constants.busV44UrlPublic}/quote/${this.state.subsciptionData.id}`,
            newCartData,
          )
            .then((res) => {
              if (res.data.code && res.data.code === "500") {
                this.props.setErrorMessage(res.data.reason, false);
                this.setState({ loading: false });
              } else {
                this.props.router.navigate("/quote/" + res.data.quoteId);
                // this.props.setQuote(res.data);
                // this.setState({ loading: false });
                // this.props.router.navigate("/quote");
              }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        } else if (
          this.state.quotedData &&
          this.state.quotedData.originalQuoteId
        ) {
          newCartData.action = "EDIT_QUOTE";
          newCartData.discount = this.state.quotedData.discountPercentage
            ? this.state.quotedData.discountPercentage
            : "";
          BusApiCall(
            "PATCH",
            `${constants.busV44UrlPublic}/quote/${this.state.quotedData.originalQuoteId}`,
            newCartData,
          )
            .then((res) => {
              if (res.data.code && res.data.code === "500") {
                this.props.setErrorMessage(res.data.reason, false);
                this.setState({ loading: false });
              } else {
                this.props.setQuote(res.data);
                this.setState({ loading: false });
                this.props.router.navigate(
                  "/quote/" + this.state.quotedData.originalQuoteId,
                );
              }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        } else if (
          this.props.shoppingQuote &&
          Array.isArray(this.props.shoppingQuote) &&
          this.props.shoppingQuote.length > 0 &&
          this.props.shoppingQuote[0].cartItem
        ) {
          if (
            this.props.shoppingQuote[0].quoteStatus === "QUO_REVIEW" ||
            this.props.shoppingQuote[0].quoteStatus === "QUO_APPROVED" ||
            this.props.shoppingQuote[0].quoteStatus === "QUO_ORDERED" ||
            this.props.shoppingQuote[0].quoteStatus === "QUO_WAIT_ORDER"
          ) {
            var data = {
              id: this.props.shoppingQuote[0].id,
            };
            this.setState({ loading: false });
            this.props.setErrorMessage(
              this.props.t("QUOTE_ALREADY_IN_PROGRESS", { data }),
              false,
              true,
            );
            return;
          }
          newCartData.action = "EDIT_QUOTE";
          newCartData.discount = this.props.shoppingQuote[0].discountPercentage
            ? this.props.shoppingQuote[0].discountPercentage
            : "";
          BusApiCall(
            "PATCH",
            `${constants.busV44UrlPublic}/quote/${this.props.shoppingQuote[0].id}`,
            newCartData,
          )
            .then((res) => {
              if (res.data.code && res.data.code === "500") {
                this.props.setErrorMessage(res.data.reason, false);
                this.setState({ loading: false });
              } else {
                this.props.setQuote(res.data);
                this.setState({ loading: false });
                this.props.router.navigate("/quote");
              }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        } else {
          newCartData.action = "CREATE_QUOTE";
          BusApiCall("POST", `${constants.busV44UrlPublic}/quote`, newCartData)
            .then((res) => {
              if (res.data.code && res.data.code === "500") {
                this.props.setErrorMessage(res.data.reason, false);
                this.setState({ loading: false });
              } else {
                if (this.state.isSubscriptionMode || this.state.isLeadQuote) {
                  this.props.router.navigate("/quote/" + res.data.quoteId);
                } else {
                  this.props.setQuote(res.data);
                  this.setState({ loading: false });
                  this.props.router.navigate("/quote");
                }
              }
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        }
      }
    }
  };

  createCartObject = () => {
    // check for required items
    let componentData = [...this.state.componentData];
    if (this.state.selectedAuxiliaryProducts.length > 0) {
      componentData.push(...this.state.selectedAuxiliaryProducts);
    }

    let currentBucket = this.state.sortedComponentList[this.state.activeStep];
    let selectedBucketItems = jp.query(
      componentData,
      '$..[?(@.componentType ==="' + currentBucket.id + '")]',
    );
    let selectionType = this.state.selectionType[currentBucket.id];
    if (selectionType === "SINGLE" || selectionType === "MULTIPLE") {
      if (selectedBucketItems.some((e) => e.selected)) {
        // Do something if selected item found 
      } else if (selectionType === "LIMIT") {
        const minLimit = this.state.selectionTypeMinLimit[currentBucket.id] || 0;
        const maxLimit = this.state.selectionTypeMaxLimit[currentBucket.id] || Infinity;
        const selectedCount = selectedBucketItems.filter(e => e.selected).length;

        if (selectedCount < minLimit) {
          this.props.setErrorMessage(
            `Minimum ${minLimit} ${currentBucket.name}(s) required.`,
            false
          );
          return;
        }

        if (selectedCount > maxLimit) {
          this.props.setErrorMessage(
            `Maximum ${maxLimit} ${currentBucket.name}(s) allowed.`,
            false
          );
          return;
        }
      } else {
        this.props.setErrorMessage(currentBucket.name + " is required.", true);
        return;
      }
    } else if (selectionType === "ALL") {
      const selectedItemsList = selectedBucketItems
        .filter((a) => a.selected)
        .map((ele) => ele.id);
      if (selectedBucketItems.length === selectedItemsList.length) {
        // All items selected
      } else {
        this.props.setErrorMessage(
          "All " + currentBucket.displayNamePlural
            ? currentBucket.displayNamePlural
            : currentBucket.name + " required.",
          true,
        );
        return;
      }
    }
    this.setState({ loading: true });

    // Create cart data
    let sol = {
      id: this.state.id,
      name: this.state.basicDetail.productName,
      quantity: this.state.quantity,

      releaseDate: this.state.basicDetail.releaseDate,
      providerId: this.state.providerId,
      originalProviderId: this.state.basicDetail.originalProviderId,
      tenantId: this.props.tenantId,
      selectedPromo: this.state.selectedPromo,
      discount: 0,
    };
    sol.associatedItems = [];
    let tempAssociatedItems = [];
    for (var i = 0; i < componentData.length; i++) {
      if (componentData[i].selected && componentData[i].quantity > 0) {
        if (componentData[i].variants && componentData[i].variants.length > 0) {
          for (var v = 0; v < componentData[i].variants.length; v++) {
            if (componentData[i].variants[v].selected) {
              componentData[i].variants[v].name =
                componentData[i].name +
                " - " +
                componentData[i].variants[v].name;
              componentData[i].variants[v].componentType =
                componentData[i].componentType;
              componentData[i].variants[v].physical = componentData[i].physical;
              componentData[i].variants[v].relationShips =
                componentData[i].relationShips;
              componentData[i].variants[v].quantity = componentData[i].quantity;
              componentData[i].variants[v].customerViewable =
                componentData[i].customerViewable;
              componentData[i].variants[v].price = this.getPriceWithPromo(
                componentData[i].variants[v].price,
                componentData[i].variants[v].id,
                componentData[i].variants[v].priceType,
              );
              tempAssociatedItems.push(componentData[i].variants[v]);
            }
          }
        } else {
          componentData[i].price = this.getPriceWithPromo(
            componentData[i].price,
            componentData[i].id,
            componentData[i].priceType,
          );
          tempAssociatedItems.push(componentData[i]);
        }
      }
    }

    let sortedComponentList = this.state.componentTypeList.sort((a, b) =>
      a.sequenceNum > b.sequenceNum
        ? 1
        : b.sequenceNum > a.sequenceNum
          ? -1
          : 0,
    );
    sortedComponentList.forEach((key, index) => {
      tempAssociatedItems.filter((item) => {
        if (item.componentType === key.id) {
          sol.associatedItems.push(item);
        }
      });
    });
    // this.props.addToCart(sol, []);
    // this.props.router.navigate("/cart");

    // new cart code
    var newCartData = {};
    newCartData.cartItem = [];

    if (this.props.publicBrowsing) {
      newCartData.relatedParty = [];
    } else {
      var selectedCustomer = JSON.parse(
        localStorage.getItem("preSelectedCustomer"),
      );
      if (selectedCustomer.childFirstName) {
        newCartData.relatedParty = [
          {
            // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.partyId : '',
            id:
              selectedCustomer && selectedCustomer.ban
                ? selectedCustomer.ban
                : "",
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.childFirstName,
            lastName: selectedCustomer.childLastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      } else {
        newCartData.relatedParty = [
          {
            // id: (selectedCustomer && selectedCustomer.ban) ? selectedCustomer.ban : selectedCustomer.partyId,
            id:
              selectedCustomer && selectedCustomer.ban
                ? selectedCustomer.ban
                : "",
            partyId: selectedCustomer.partyId,
            firstName: selectedCustomer.firstName,
            lastName: selectedCustomer.lastName,
            role:
              selectedCustomer && selectedCustomer.role
                ? selectedCustomer.role
                : "",
          },
        ];
      }
    }
    var tempPSData = {
      action: "ADD",
      productOffering: {
        id: this.state.id,
        name: this.state.basicDetail.productName,
        quantity: +this.state.quantity,
        includedItems: [],
      },
    };
    if (this.state.selectedPromo && this.state.selectedPromo.id) {
      tempPSData.productOffering.specialPricingCode =
        this.state.selectedPromo.id;
    }
    if (
      this.props.shoppingCart &&
      Array.isArray(this.props.shoppingCart) &&
      this.props.shoppingCart.length > 0 &&
      this.props.shoppingCart[0].cartItem &&
      this.props.shoppingCart[0].cartItem.length > 0
    ) {
      tempPSData.index =
        this.props.shoppingCart[0].cartItem[
          this.props.shoppingCart[0].cartItem.length - 1
        ].index + 1;
    } else {
      tempPSData.index = 0;
    }
    var finalAssociatedItems = [];
    var sortedIAssociatedItems = [];
    for (var i = 0; i < sortedComponentList.length; i++) {
      let bItems = jp.query(
        tempAssociatedItems,
        '$[?(@.componentType=="' + sortedComponentList[i].id + '")]',
      );
      sortedIAssociatedItems = sortedIAssociatedItems.concat(bItems);
      finalAssociatedItems = finalAssociatedItems.concat(bItems);
    }

    for (var j = 0; j < tempAssociatedItems.length; j++) {
      var index = sortedIAssociatedItems.findIndex(
        (a) => a.id === tempAssociatedItems[j].id,
      );
      if (index > -1) {
      } else {
        finalAssociatedItems.push(tempAssociatedItems[j]);
      }
    }
    finalAssociatedItems = finalAssociatedItems.filter(item => item.quantity > 0);
    for (var i = 0; i < finalAssociatedItems.length; i++) {
      var item = {
        id: finalAssociatedItems[i].id,
        // name: finalAssociatedItems[i].name,
        quantity: +finalAssociatedItems[i].quantity,
        // price: finalAssociatedItems[i].price.purchasePrice,
        // priceType: finalAssociatedItems[i].priceTenureUOM ? 'NTC' : finalAssociatedItems[i].priceType,
      };
      // PSC_CUST_FACING
      if (
        finalAssociatedItems[i].productSpec &&
        finalAssociatedItems[i].productSpec.category
      ) {
        // if (finalAssociatedItems[i].productSpec.category.id === 'PSC_CUST_FACING') {
        if (
          finalAssociatedItems[i].characteristics &&
          finalAssociatedItems[i].characteristics.length > 0
        ) {
          item.productCharsOverride = [];
          finalAssociatedItems[i].characteristics.map((char) =>
            item.productCharsOverride.push({
              name: char.name,
              value: char.value,
              specId: char.specId,
              id: char.id,
            }),
          );
        }
        // }
      }
      if (finalAssociatedItems[i].priceTenureUOM) {
        // item.priceTenure = finalAssociatedItems[i].priceTenure;
        // item.priceTenureUOM = finalAssociatedItems[i].priceTenureUOM;
      }
      tempPSData.productOffering.includedItems.push(item);
    }
    newCartData.cartItem.push(tempPSData);
    if (tempPSData.productOffering.includedItems.length === 0) {
      this.setState({ loading: false });
      this.props.setErrorMessage(
        this.props.t("NO_ITEMS_SELECTED_TO_ADD_TO_CART"),
        false,
      );
      return;
    }
    console.log("final payload", newCartData);
    // return;
    if (this.props.publicBrowsing) {
      sessionStorage.setItem("publicCart", JSON.stringify(newCartData));
      window.localStorage.setItem("doLogin", true);
      window.location.reload();
    } else {
      if (this.props.providerType === "SOLUTION_PROVIDER") {
        newCartData.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      if (
        this.props.shoppingCart &&
        Array.isArray(this.props.shoppingCart) &&
        this.props.shoppingCart.length > 0 &&
        this.props.shoppingCart[0].cartItem
      ) {
        BusApiCall(
          "PATCH",
          `${constants.busPublicServiceUrl}/shoppingCart/${this.props.shoppingCart[0].id}`,
          newCartData,
        )
          .then((res) => {
            if (res.data.code && res.data.code === "500") {
              this.props.setErrorMessage(res.data.reason, false);
              this.setState({ loading: false });
            } else {
              this.props.setCart(res.data);
              this.setState({ loading: false });
              this.props.router.navigate("/cart");
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      } else {
        BusApiCall(
          "POST",
          `${constants.busPublicServiceUrl}/shoppingCart`,
          newCartData,
        )
          .then((res) => {
            if (res.data.code && res.data.code === "500") {
              this.props.setErrorMessage(res.data.reason, false);
              this.setState({ loading: false });
            } else {
              this.props.setCart(res.data);
              this.setState({ loading: false });
              this.props.router.navigate("/cart");
            }
          })
          .catch((err) => {
            if (
              err.response &&
              err.response.data &&
              err.response.data.message
            ) {
              this.props.setErrorMessage(err.response.data.message, false);
            } else {
              this.props.setErrorMessage(
                this.props.t("DEFAULT_ERROR_MESSAGE"),
                false,
              );
            }
            this.setState({
              loading: false,
            });
          });
      }
    }
  };

  // This function check if there is any promo applied on the item and return price according to that
  getPriceWithPromo = (price, id, priceType) => {
    let promo = this.state.selectedPromo;
    if (promo && promo.priceAdjustments) {
      let pPrice = promo.priceAdjustments[id]
        ? parseFloat(promo.priceAdjustments[id].price)
        : null;
      if (pPrice) {
        if (priceType === "RC") {
          price.recurringPrice.price = pPrice;
          return price;
        } else {
          price.purchasePrice = pPrice;
          return price;
        }
      } else {
        return price;
      }
    } else {
      return price;
    }
  };

  emptyBucketCheck = () => {
    let allBuckets = [...this.state.sortedComponentList];
    let allComponents = [...this.state.componentData];
    // this.state.activeStep === 0 || item.defaultSelected || this.isDependerSelected(item)) && item.customerViewable && (
    let count = 0;
    for (var i = 0; i < allBuckets.length; i++) {
      if (i === this.state.activeStep) {
        for (var j = 0; j < allComponents.length; j++) {
          if (allBuckets[i].id === allComponents[j].componentType) {
            if (
              (allComponents[j].defaultSelected ||
                this.isDependerSelected(allComponents[j])) &&
              allComponents[j].customerViewable
            ) {
              count++;
            }
          }
        }
      }
    }
    this.setState({
      availableItemCount: count,
    });
  };

  // This function is used to select/change promo
  // and update price according to selected promo
  onChangePromo = (e) => {
    const index = this.state.promos.findIndex((a) => a.id === e.target.value);
    if (index > -1) {
      this.setState({
        selectedPromo: this.state.promos[index],
      });
    } else {
      this.setState({
        selectedPromo: "",
      });
    }
  };

  // Check for same promo BAN
  verifyPromoBan = async () => {
    this.setState({ loading: true });
    // Check if user came from update order page
    if (this.props.router.params.orderId) {
      // this.setState({ loading: false })
      // this.addToCart();
    } else {
      // Check if promo is selected
      if (this.state.selectedPromo) {
        // Get BAN for selected promo
        let jsonData = {};
        if (this.state.parentTenantId) {
          jsonData = {
            tenantId: this.state.parentTenantId,
          };
        }
        BusApiCall(
          "GET",
          `${constants.busInternalUrl}/promos/${this.state.selectedPromo.id}`,
          jsonData,
        ).then((res) => {
          if (res.data.promoType === "PPC_OPEX") {
            this.setOpexOnPrice(res.data.noOfOpexMonths);
          }
          // If promo is available for all BANs
          if (res.data.promoCustomerList[0].partyId === "all") {
            this.setState({ loading: false });
            this.showSteps();
            // return true;
            // this.addToCart();
          } else {
            // check for old BAN in store
            if (this.props.selectedPromoBan) {
              // If old BAN found then compare for similar BAN
              if (
                this.props.selectedPromoBan !==
                res.data.promoCustomerList[0].customerBan
              ) {
                // If BAN is not same then show error
                this.props.setErrorMessage(
                  this.props.t(
                    "CANNOT_SELECT_A_SPECIAL_PRICING_FOR_MULTIPLE_CUSTOMER_BANS_AT_THE_SAME_TIME",
                  ),
                );
                this.setState({ loading: false });
                return false;
              } else {
                // If BAN is same then add item to cart
                this.setState({ loading: false });
                this.showSteps();
                // this.addToCart();
              }
            } else {
              // If BAN not found then store selected promo BAN
              this.props.setPromoBan(res.data.promoCustomerList[0].customerBan);
              this.setState({ loading: false });
              this.showSteps();
              // this.addToCart();
            }
          }
        });
      } else {
        // If promo not found add item to cart
        this.setState({ loading: false });
        this.showSteps();
        // this.addToCart();
      }
    }
  };

  setOpexOnPrice = (opexTenure) => {
    let components = [...this.state.componentData];
    for (var i = 0; i < components.length; i++) {
      if (components[i].originalPriceType === "NRC") {
        let newPrice = (components[i].originalPrice / opexTenure).toFixed(2);
        components[i].price = {
          recurringPrice: {
            termUomId: null,
            price: newPrice,
          },
          purchasePrice: newPrice,
        };
        components[i].priceType = "RC";
      }
    }
  };

  checkAvailability = () => {
    this.setState({
      openVerifyDialog: true,
    });
  };
  closeVerifyDialog = (val) => {
    if (val) {
      this.setState({ loading: true });
      var payload = {
        description: this.state.name,
        note: [],
        productOfferingQualificationItem: [],
        relatedParty: [
          {
            id: this.state.customerDetails.partyId,
            name: this.state.customerDetails.accountName,
          },
        ],
      };

      var psQualifications = jp.query(
        this.state.preQualsData,
        '$[?(@.productId=="' + this.state.id + '")]',
      );
      if (psQualifications && psQualifications.length > 0) {
        var tempItem = {
          action: "ADD",
          note: [],
          productOffering: {
            id: this.state.id,
            name: this.state.name,
            qualificationResources: [],
          },
        };
        for (var i = 0; i < psQualifications.length; i++) {
          tempItem.productOffering.qualificationResources.push({
            id: psQualifications[i].resourceId,
            parameters: psQualifications[i].parameters,
          });
          if (i + 1 === psQualifications.length) {
            payload.productOfferingQualificationItem.push(tempItem);
          }
        }
      }
      for (var i = 0; i < this.state.componentData.length; i++) {
        var productQualifications = jp.query(
          this.state.preQualsData,
          '$[?(@.productId=="' + this.state.componentData[i].id + '")]',
        );
        if (productQualifications && productQualifications.length > 0) {
          var tempItem = {
            action: "ADD",
            note: [],
            productOffering: {
              id: this.state.componentData[i].id,
              name: this.state.componentData[i].name,
              qualificationResources: [],
            },
          };
          for (var j = 0; j < productQualifications.length; j++) {
            tempItem.productOffering.qualificationResources.push({
              id: productQualifications[j].resourceId,
              parameters: productQualifications[j].parameters,
            });
            if (j + 1 === productQualifications.length) {
              payload.productOfferingQualificationItem.push(tempItem);
            }
          }
        }
      }
      // for (var i = 0; i < data.preQuals.length; i++) {
      //     var preQual = {
      //         resourceId: data.preQuals[i].resourceId,
      //         param: []
      //     };
      //     for (var j = 0; j < data.preQuals[i].parameters.length; j++) {
      //         var param = {
      //             name: data.preQuals[i].parameters[j].name,
      //             value: data.preQuals[i].parameters[j].value ? data.preQuals[i].parameters[j].value : ''
      //         }
      //         preQual.param.push(param);
      //     }
      //     payload.preQuals.push(preQual)
      // }
      //console.log("check final data", payload);
      // this.setState({
      //     openVerifyDialog: false
      // })

      if (this.props.providerType === "SOLUTION_PROVIDER") {
        payload.tenantId = localStorage.getItem("selectedSalesChannel");
      }
      // Add API here
      BusApiCall(
        "POST",
        `${constants.busV4Url}/productOfferingQualification`,
        payload,
      )
        .then((res) => {
          if (res.data.qualificationResult === "UNQUALIFIED") {
            var productOfferingQualificationItem =
              res.data.productOfferingQualificationItem;
            for (var i = 0; i < productOfferingQualificationItem.length; i++) {
              var qualificationResources =
                productOfferingQualificationItem[i].productOffering
                  .qualificationResources;
              for (var j = 0; j < qualificationResources.length; j++) {
                if (
                  qualificationResources[j].qualificationItemResult ===
                  "UNQUALIFIED"
                ) {
                  this.setState({
                    loading: false,
                    preQualMessage:
                      qualificationResources[j].eligibilityUnavailabilityReason
                        .label,
                    placeOrder: false,
                    showCheckAvailability: true,
                  });
                  return;
                }
              }
            }
          } else {
            this.setState({
              loading: false,
              preQualMessage: "User is qualified for offering.",
              placeOrder: true,
              showCheckAvailability: false,
            });
          }
        })
        .catch((err) => {
          this.setState({
            loading: false,
            preQualMessage: err.response.data.message,
          });
          // this.setState({ loading: false, preQualMessage: err.response.data.message })
          // if (err.response && err.response.data && err.response.data.message) {
          //     this.props.setErrorMessage(err.response.data.message, false)
          // } else {
          //     this.props.setErrorMessage(this.props.t('DEFAULT_ERROR_MESSAGE'), false)
          // }
        });
    } else {
      this.setState(
        {
          openVerifyDialog: false,
          preQualMessage: "",
        },
        () => {
          this.clearPrequalsData();
        },
      );
    }
  };

  clearPrequalsData = () => {
    var preQualsData = [...this.state.preQualsData];
    for (var i = 0; i < preQualsData.length; i++) {
      for (var j = 0; j < preQualsData[i].parameters.length; j++) {
        if (preQualsData[i].parameters[j].type === "boolean") {
          preQualsData[i].parameters[j].value = false;
        } else {
          preQualsData[i].parameters[j].value = "";
        }
      }
      if (i + 1 === preQualsData.length) {
        this.setState({
          preQualsData,
        });
      }
    }
  };

  onChangePreQualData = (e, resIndex, paramIndex) => {
    var preQualsData = this.state.preQualsData;
    var resource = preQualsData[resIndex];
    var param = resource.parameters[paramIndex];
    var value = e.target.value;
    if (param.type === "boolean") {
      if (param.value) {
        param.value = false;
      } else {
        param.value = true;
      }
    } else {
      param.value = value;
    }
    resource.parameters[paramIndex] = param;
    preQualsData[resIndex] = resource;
    this.setState({
      preQualsData,
    });
  };

  selectCustomerClose = (
    currStage,
    data,
    selectedTreeItems,
    selectedPaymentMethod,
  ) => {
    if (
      data.shipping &&
      (data.shipping.street1 === "" ||
        data.shipping.city === "" ||
        data.shipping.state === "" ||
        data.shipping.country === "")
    ) {
      this.setState({ err: this.props.t("SHIPPING_ADDRESS_MISSING") });
    } else {
      if (this.state.placeOrder && this.state.preQualsData.length > 0) {
        var oldCustomer = JSON.parse(
          localStorage.getItem("preSelectedCustomer"),
        );
        if (oldCustomer && oldCustomer.partyId !== data.partyId) {
          this.resetWizard();
          this.setState({
            showSteps: false,
            placeOrder: false,
            showCheckAvailability: true,
            openVerifyDialog: true,
          });
        }
      }
      localStorage.setItem("preSelectedCustomer", JSON.stringify(data));
      localStorage.setItem(
        "preSelectedPaymentMethod",
        JSON.stringify(selectedPaymentMethod),
      );
      if (data.childFirstName) {
        this.getCustomerCart(data.partyId);
      } else {
        this.getCustomerCart(data.partyId, data.ban);
      }
      this.setState(
        {
          customerDetails: data,
          selectedTreeItems: selectedTreeItems,
          selectedPaymentMethod: selectedPaymentMethod,
          showSelectCustomer: false,
          err: "",
          loading: true,
        },
        () => {
          this.getOfferingData();
        },
      );
    }
  };

  getCustomerCart = (id, ban) => {
    // this.setState({ loading: true });
    var jsonData = {};
    if (this.props.providerType === "SOLUTION_PROVIDER") {
      jsonData.tenantId = localStorage.getItem("selectedSalesChannel");
    }
    BusApiCall(
      "GET",
      `${constants.busPublicServiceUrl}/shoppingCart?partyId=${id}${ban ? "&customerId=" + UriEncode(ban) : ""}`,
      jsonData,
    )
      .then((res) => {
        this.props.setCart(res.data);
        // this.setState({ loading: false });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        // this.setState({ loading: false });
      });
    if (this.state.modules && this.state.modules.module_quote === "enabled") {
      var quoteType = "NewActivation";
      if (
        this.state.isSubscriptionMode &&
        this.state.subsciptionData.mode &&
        this.state.subsciptionData.mode === "ChangeSubscription"
      ) {
        quoteType = this.state.subsciptionData.mode;
      }
      BusApiCall(
        "GET",
        `${constants.busV44UrlPublic}/quote?customerId=${id}&type=${quoteType}`,
        jsonData,
      )
        .then((res) => {
          this.props.setQuote(res.data);
          if (res.data && res.data.length > 0) {
            var data = {
              id: res.data[0].id,
            };
            if (quoteType === "ChangeSubscription") {
              this.setState({
                oldChangeSubscriptionData: res.data[0],
              });
            }
            if (
              res.data[0].quoteStatus === "QUO_REVIEW" ||
              res.data[0].quoteStatus === "QUO_APPROVED" ||
              res.data[0].quoteStatus === "QUO_ORDERED" ||
              res.data[0].quoteStatus === "QUO_WAIT_ORDER"
            ) {
              this.setState({
                disableCreateQuote: true,
              });
              // this.props.setErrorMessage(this.props.t('QUOTE_ALREADY_IN_REVIEW', { data }), false, true);
              this.props.setErrorMessage(
                this.props.t("QUOTE_ALREADY_IN_PROGRESS", { data }),
                false,
                true,
              );
            } else {
              this.setState({
                disableCreateQuote: false,
              });
            }
            // if (res.data[0].quoteStatus === 'QUO_APPROVED') {
            //     this.props.setErrorMessage(this.props.t('QUOTE_ALREADY_IN_APPROVED', { data }), false, true);
            // }
          } else {
            this.setState({
              disableCreateQuote: false,
            });
          }
          // this.setState({ loading: false });
        })
        .catch((err) => {
          this.setState({
            disableCreateQuote: false,
          });
          if (err.response && err.response.data && err.response.data.message) {
            this.props.setErrorMessage(err.response.data.message, false);
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
          // this.setState({ loading: false });
        });
    }
  };

  closeDialog = () => {
    var customer = localStorage.getItem("preSelectedCustomer");
    if (customer) {
      this.setState({
        showSelectCustomer: false,
      });
    } else {
      this.props.router.navigate(-1);
    }
  };

  resetSelecteddata = () => {
    // this.setState({
    //     customerDetails: {},
    //     selectedTreeItems: [],
    //     selectedPaymentMethod: null
    // })
  };

  changeCustomer = () => {
    this.setState({
      showSelectCustomer: true,
    });
  };

  removeCustomerForm = () => {
    this.setState({
      showNewCustomer: false,
      showSelectCustomer: true,
    });
  };

  closeErrorMessage = (error, type) => {
    this.props.setErrorMessage(error, type);
  };

  // This function is used to check new/update customer data
  addCustomer = (data) => {
    this.setState({
      loading: true,
    });
    let contact = {
      ...data,
    };
    delete contact.billing;
    delete contact.shipping;
    delete contact.paymentInstrumentsMap;
    delete contact.paymentMethod;
    let banDetails = {
      accountName: data.accountName,
      ban: data.ban,
      partyId: data.partyId,
      label: data.label,
      value: data.ban,
    };
    let newData = {
      banDetails: banDetails,
      contact: contact,
      billing: data.billing,
      shipping: data.shipping,
      // paymentInstrumentsMap: data.paymentInstrumentsMap ? data.paymentInstrumentsMap : null
      paymentInstrumentsMap: null,
    };
    BusApiCall("POST", `${constants.busInternalUrl}/customers`, newData)
      .then((res) => {
        if (data.paymentInstrumentsMap) {
          let paymentData = {
            contact: {
              firstName: newData.contact.firstName,
              lastName: newData.contact.lastName,
              partyId: res.data.customer.partyId,
              officePhone: newData.contact.officePhone,
              mobilePhone: newData.contact.mobilePhone,
              email: newData.contact.email,
              emailMechId: res.data.customer.emailMechId,
              mobilePhoneMechId: res.data.customer.mobilePhoneMechId,
              officePhoneMechId: res.data.customer.officePhoneMechId,
              billingCloseDay: newData.contact.billingCloseDay,
            },
            billing: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            shipping: {
              attention: "",
              phone: "",
              street1: "",
              street2: "",
              city: "",
              state: "",
              zip: "",
              country: "",
            },
            banDetails: {
              accountName: data.accountName,
              ban: data.ban,
            },
          };
          if (data.paymentInstrumentsMap.creditCard) {
            let cardData = data.paymentInstrumentsMap.creditCard;
            let creditCard = {
              cardType: cardData.cardType,
              isPrimary: cardData.isPrimary,
              cardNumber: cardData.cardNumber,
              expireDate: cardData.expireDate,
              nameOnCard:
                cardData.firstNameOnCard + " " + cardData.lastNameOnCard,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              creditCard: creditCard,
            };
            paymentData.paymentInstrumentsMap = payment;
          } else if (data.paymentInstrumentsMap.eftAccount) {
            let eftAccount = {
              ...data.paymentInstrumentsMap.eftAccount,
              ...data.billing,
              billingContactMechId: res.data.customer.billing.postalMechId,
            };
            let payment = {
              eftAccount: eftAccount,
            };
            paymentData.paymentInstrumentsMap = payment;
          }
          BusApiCall(
            "POST",
            `${constants.busInternalUrl}/customers`,
            paymentData,
          )
            .then((paymentRes) => {
              this.setNewCustomerAsPreSelected(
                data,
                res.data.customer,
                paymentRes.data.customer,
              );
              this.setState({
                loading: false,
                newCustomerDetails: {},
                showNewCustomer: false,
              });
              var customer = {
                accountName: newData.banDetails.accountName,
              };
              this.props.setErrorMessage(
                this.props.t("CUSTOMER_CREATED_SUCCESSFULLY", { customer }),
                true,
              );
            })
            .catch((err) => {
              if (
                err.response &&
                err.response.data &&
                err.response.data.message
              ) {
                this.props.setErrorMessage(err.response.data.message, false);
              } else {
                this.props.setErrorMessage(
                  this.props.t("DEFAULT_ERROR_MESSAGE"),
                  false,
                );
              }
              this.setState({
                loading: false,
              });
            });
        } else {
          this.setNewCustomerAsPreSelected(data, res.data.customer, null);
          this.setState({
            loading: false,
            newCustomerDetails: {},
            showNewCustomer: false,
          });
          let customer = {
            accountName: newData.banDetails.accountName,
          };
          this.props.setErrorMessage(
            this.props.t("CUSTOMER_CREATED_SUCCESSFULLY", { customer }),
            true,
          );
          this.removeCustomerForm();
        }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({
          loading: false,
        });
      });
  };

  setNewCustomerAsPreSelected = (customer, customerIds, paymentIds) => {
    var preSelectedCustomer = { ...customer };
    preSelectedCustomer.partyId = customerIds.partyId;
    preSelectedCustomer.officePhoneMechId = customerIds.officePhoneMechId;
    preSelectedCustomer.mobilePhoneMechId = customerIds.mobilePhoneMechId;
    preSelectedCustomer.emailMechId = customerIds.emailMechId;
    preSelectedCustomer.role = customerIds.role ? customerIds.role : "Customer";

    preSelectedCustomer.billing.postalMechId = customerIds.billing.postalMechId;
    preSelectedCustomer.billing.phoneMechId = customerIds.billing.phoneMechId;

    preSelectedCustomer.shipping.postalMechId =
      customerIds.shipping.postalMechId;
    preSelectedCustomer.shipping.phoneMechId = customerIds.shipping.phoneMechId;

    if (paymentIds) {
      var method = JSON.parse(paymentIds.paymentMethod);
      if (customer.paymentInstrumentsMap.creditCard) {
        let cardData = customer.paymentInstrumentsMap.creditCard;
        let creditCard = {
          cardType: cardData.cardType,
          isPrimary: cardData.isPrimary,
          cardNumber: cardData.cardNumber,
          expireDate: cardData.expireDate,
          nameOnCard: cardData.firstNameOnCard + " " + cardData.lastNameOnCard,
          ...customer.billing,
          billingContactMechId: customerIds.billing.postalMechId,
          paymentMethodId: method.paymentMethodId,
        };
        preSelectedCustomer.paymentMethod = {
          creditCards: [{ ...creditCard }],
        };
      } else if (customer.paymentInstrumentsMap.eftAccount) {
        let eftAccount = {
          ...customer.paymentInstrumentsMap.eftAccount,
          ...customer.billing,
          billingContactMechId: customerIds.billing.postalMechId,
          paymentMethodId: method.paymentMethodId,
        };
        preSelectedCustomer.paymentMethod = {
          eftAccount: [{ ...eftAccount }],
        };
      }
    } else {
      preSelectedCustomer.paymentMethod = {};
    }

    delete preSelectedCustomer.paymentInstrumentsMap;

    localStorage.setItem(
      "preSelectedCustomer",
      JSON.stringify(preSelectedCustomer),
    );
    localStorage.setItem(
      "preSelectedPaymentMethod",
      JSON.stringify(preSelectedCustomer.paymentMethod),
    );
    this.props.setCart([]);
    this.props.setQuote([]);
    this.setState({
      customerDetails: preSelectedCustomer,
      selectedPaymentMethod: preSelectedCustomer.paymentMethod,
      showSelectCustomer: false,
      showNewCustomer: false,
      showSteps: false,
    });
    if (this.state.placeOrder && this.state.preQualsData.length > 0) {
      this.resetWizard();
      this.setState({
        placeOrder: false,
        showCheckAvailability: true,
        openVerifyDialog: true,
      });
    }
  };

  onLanguageChange = (e) => {
    this.setState(
      {
        language: e.target.value,
      },
      () => {
        if (this.state.localisedName) {
          var index = this.state.localisedName.findIndex(
            (x) => x.locale === this.state.language,
          );
          if (index > -1) {
            this.setState({
              name: this.state.localisedName[index].text,
            });
          }
        }

        if (this.state.localisedOverview) {
          var index = this.state.localisedOverview.findIndex(
            (x) => x.locale === this.state.language,
          );
          if (index > -1) {
            this.setState({
              overView: this.state.localisedOverview[index].text,
              noOverview: false,
            });
          } else {
            this.setState({
              overView:
                '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
              noOverview: true,
            });
          }
        }
        if (this.state.localisedTechSpecs) {
          var index = this.state.localisedTechSpecs.findIndex(
            (x) => x.locale === this.state.language,
          );
          if (index > -1) {
            this.setState({
              techSpecs: this.state.localisedTechSpecs[index].text,
              noTechspecs: false,
            });
          } else {
            this.setState({
              techSpecs:
                '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
              noTechspecs: true,
            });
          }
        }

        if (this.state.localisedWhatsIncluded) {
          var index = this.state.localisedWhatsIncluded.findIndex(
            (x) => x.locale === this.state.language,
          );
          if (index > -1) {
            this.setState({
              whatsIncluded: this.state.localisedWhatsIncluded[index].text,
              noWhatsincluded: false,
            });
          } else {
            this.setState({
              whatsIncluded:
                '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
              noWhatsincluded: true,
            });
          }
        }

        for (var i = 0; i < this.state.componentData.length; i++) {
          if (this.state.componentData[i]) {
            var index = this.state.componentData[i].localisedName.findIndex(
              (x) => x.locale === this.state.language,
            );
            if (index > -1) {
              this.state.componentData[i].name =
                this.state.componentData[i].localisedName[index].text;
            }

            var index = this.state.componentData[i].localisedDesc.findIndex(
              (x) => x.locale === this.state.language,
            );
            if (index > -1) {
              this.state.componentData[i].description =
                this.state.componentData[i].localisedDesc[index].text;
            }
          }
        }
      },
    );
  };

  getPriceTenureUOM = (val) => {
    if (val === "TF_day") {
      return "Day";
    } else if (val === "TF_hr" || val === "HOUR") {
      return "Hour";
    } else if (val === "TF_wk") {
      return "Week";
    } else if (val === "TF_mon") {
      return "Month";
    } else if (val === "TF_yr") {
      return "Year";
    } else if (val === "DAY") {
      return "Day";
    } else if (val === "WEEK") {
      return "Week";
    } else if (val === "MONTH") {
      return "Month";
    } else if (val === "YEAR") {
      return "Year";
    } else {
      return "";
    }
  };

  openProductSpecification = (product) => {
    // this.setState({
    //     selectedProductSpecification: product,
    //     showProductSpecification: true,
    // })
  };

  handleCloseSpecificationDialog = () => {
    // this.setState({
    //     selectedProductSpecification: {},
    //     showProductSpecification: false,
    // });
  };

  handleCharacteristicsUpdate = (item, updatedCharacteristics) => {
    var product = item;
    product.characteristics = updatedCharacteristics;
    var productsList = [...this.state.componentData];
    var productIndex = productsList.findIndex((x) => x.id === product.id);
    productsList[productIndex].characteristics = updatedCharacteristics;
    this.setState(
      {
        componentData: productsList,
      },
      () => { },
    );
  };

  findMatchingDependency = (dependencies, dependerQuantity, dependerId) => {
    // Filter dependencies for this specific depender
    const relevantDeps = dependencies.filter(dep => dep.depender === dependerId);

    if (relevantDeps.length === 0) return null;

    // Check if there's a dependency without quantity constraints (should match any quantity)
    const unconstainedDep = relevantDeps.find(dep => {
      const min = dep.quantity?.range?.min;
      const max = dep.quantity?.range?.max;
      // Return dependency if quantity range is not set or is 0/empty
      return !min || min === '' || min === 0 || !max || max === '' || max === 0;
    });

    if (unconstainedDep) {
      return unconstainedDep;
    }

    // If only one dependency, return it
    if (relevantDeps.length === 1) {
      const dep = relevantDeps[0];
      const min = parseInt(dep.quantity?.range?.min);
      const max = parseInt(dep.quantity?.range?.max);
      if (dependerQuantity >= min && dependerQuantity <= max) {
        return dep;
      } else {
        return null;
      }
    }

    // Find the tier where dependerQuantity falls within the quantity range
    let match = relevantDeps.find(dep => {
      const min = parseInt(dep.quantity?.range?.min) || 1;
      const max = parseInt(dep.quantity?.range?.max) || Infinity;
      const isMatch = dependerQuantity >= min && dependerQuantity <= max;
      return isMatch;
      // if (dependerQuantity >= min && dependerQuantity <= max) {
      //   return dep;
      // } else {
      //   return null;
      // }
      // return dependerQuantity >= min && dependerQuantity <= max;
    });

    // Fallback: if no match found, use the highest tier
    // if (!match) {
    //   match = relevantDeps.reduce((highest, dep) => {
    //     const currentMax = parseInt(dep.quantity?.range?.max) || 0;
    //     const highestMax = parseInt(highest.quantity?.range?.max) || 0;
    //     return currentMax > highestMax ? dep : highest;
    //   });
    // }
    return match || null;
  };

  hasMatchingDependency = (data) => {
    if (!data.relationShips?.dependsOn) {
      return true; // No dependencies, always enabled
    }

    // Check if there's a matching dependency for any selected depender
    return data.relationShips.dependsOn.some(dep => {
      const depender = this.state.componentData?.find(c => c.id === dep.depender);
      
      if (!depender || !depender.selected) {
        return false;
      }

      // Use findMatchingDependency to check if current quantity matches
      const matchingDep = this.findMatchingDependency(
        data.relationShips.dependsOn,
        depender.quantity,
        depender.id
      );
      
      return matchingDep !== null;
    });
  };
  calculateDependeeQuantity = (dependency, dependerQuantity) => {
    const cardinalityQtyMin = dependency.quantity?.range?.min && parseInt(dependency.quantity?.range?.min);
    const cardinalityQtyMax = dependency.quantity?.range?.max && parseInt(dependency.quantity?.range?.max);

    // Get cardinality (dependee quantity)
    const cardinalityMin = dependency.cardinality?.range?.min !== null &&
      dependency.cardinality?.range?.min !== undefined
      ? parseInt(dependency.cardinality.range.min)
      : 1;
    const cardinalityMax = dependency.cardinality?.range?.max !== null &&
      dependency.cardinality?.range?.max !== undefined
      ? parseInt(dependency.cardinality.range.max)
      : cardinalityMin;
    // console.log('cardinalityMin', dependency, dependerQuantity);

    // When cardinality.type is null, min/max are 0, and dependency is optional
    const isFlexibleScaling = (cardinalityMin === 0 && cardinalityMax === 0 &&
      dependency.cardinality?.type === null) &&
      dependency.dependencyType !== "Mandatory";
    if (isFlexibleScaling) {
      return {
        quantity: 1,
        maxQuantity: dependerQuantity,
        isExact: false
      };
    }

    if ((!cardinalityQtyMin || cardinalityQtyMin === 0) || (!cardinalityQtyMax || cardinalityQtyMax === 0)) {
      // console.log('multiplier logic', dependerQuantity, dependency);
      return {
        quantity: cardinalityMin * dependerQuantity,
        maxQuantity: cardinalityMax * dependerQuantity,
        isExact: dependency.cardinality?.type === "Exact"
      };
    }

    if ((dependerQuantity >= cardinalityQtyMin) && (dependerQuantity <= cardinalityQtyMax)) {

      // Check if this is a tiered dependency (has quantity range defined)
      const hasTiers = (dependency.quantity?.range?.min && dependency.quantity?.range?.max) &&
        (dependency.cardinality?.range?.min <= dependency.cardinality?.range?.max);
      if (hasTiers) {
        // For tiered dependencies, use cardinality directly (tier selection already done)
        return {
          quantity: cardinalityMin,
          maxQuantity: cardinalityMax,
          isExact: dependency.cardinality?.type === "Exact"
        };
      } else {
        return {
          quantity: cardinalityMin * dependerQuantity,
          maxQuantity: cardinalityMax * dependerQuantity,
          isExact: dependency.cardinality?.type === "Exact"
        };
      }
    } else {
      return {
        quantity: 0,
        maxQuantity: 0,
        isExact: dependency.cardinality?.type === "Exact"
      };
    }
  };

  toggleOfferingQuantity = () => {
    this.setState({
      showOfferingQuantity: !this.state.showOfferingQuantity,
    }, () => {
      this.props.setShowOfferingQuantity(this.state.showOfferingQuantity);
    })
  }

  /**
   * Parses the quantity validation pattern
   */
  parseQuantityPattern = (pattern) => {
    if (!pattern) return [];

    return pattern.split(",").map(rule => {
      const [basePart, valuePart] = rule.split(".quantity=");

      const base = basePart.replace(/"/g, "").trim();

      const addons = valuePart
        .split("+")
        .map(v => v.replace(/"/g, "").trim());

      return { base, addons };
    });
  };


  /**
   * Validates that base quantity >= sum of addons quantity
   *
   * @param {Object} quantityValidationAttr
   * @param {Array} items
   *
   * items format:
   * [{ featureCode: "BASE", quantity: 5 }]
   */
  validateQuantityRules = (
    quantityValidationAttr,
    items
  ) => {

    if (
      !quantityValidationAttr ||
      !quantityValidationAttr.attrValue ||
      !Array.isArray(items)
    ) {
      return true;
    }

    const rules = this.parseQuantityPattern(
      quantityValidationAttr.attrValue
    );

    // create lookup map ONLY for selected items
    const quantityMap = {};

    items.forEach(item => {

      if (item.selected === true) {
        quantityMap[item.featureCode] =
          Number(item.quantity) || 0;
      }

    });

    for (var i = 0; i < rules.length; i++) {
      var baseQty = Number(quantityMap[rules[i].base]) || 0;
      var addonTotal = 0;

      var baseProduct = {};
      var baseIndex = items.findIndex(item => item.featureCode === rules[i].base);
      if (baseIndex > -1) {
        baseProduct = items[baseIndex];
      }
      var addonProductNames = [];

      for (var j = 0; j < rules[i].addons.length; j++) {
        var addonIndex = items.findIndex(item => item.featureCode === rules[i].addons[j] && this.isDependerSelected(item));
        if (addonIndex > -1) {
          addonProductNames.push(items[addonIndex].name);
          if (items[addonIndex].selected) {
            addonTotal += Number(items[addonIndex].quantity) || 0;
          }
        }
        if (rules[i].addons.length === (j + 1)) {
          var activeStep = this.state.steps[this.state.activeStep];
          var itemIndex = items.findIndex(item => item.featureCode === rules[i].base);
          console.log('check quantity', addonTotal, baseQty)
          if (itemIndex > -1) {
            if (items[itemIndex].componentType === activeStep.name) {
              if (addonTotal > baseQty || addonTotal < baseQty) {
                // var message = `"${baseProduct.name}" quantity should be equal to total quantity of the following services:\n${addonProductNames.join("\n")}`;
                var message = `Please ensure the combined quantity equals ${baseProduct.quantity} for the following services:\n\n${addonProductNames.join("\n")}`;
                this.props.setErrorMessage(message, false);
                return false;
              }
            }
          }
        }
      }
    }

    return true;
  };

  updatePseudoProductQuantity = () => {
    if (this.state.quantityValidationAttr && this.state.quantityValidationAttr.attrValue) {
      const rules = this.parseQuantityPattern(
        this.state.quantityValidationAttr.attrValue
      );
      var products = structuredClone(this.state.componentData);
      const quantityMap = {};

      products.forEach(item => {

        if (item.selected === true) {
          quantityMap[item.featureCode] =
            Number(item.quantity) || 0;
        }

      });
      for (var i = 0; i < rules.length; i++) {
        var baseQty = Number(quantityMap[rules[i].base]) || 0;
        var addonTotal = 0;

        var baseProduct = {};
        var baseIndex = products.findIndex(item => item.featureCode === rules[i].base);
        if (baseIndex > -1) {
          products[baseIndex].selected = true;
          baseProduct = products[baseIndex];
          if (baseProduct?.relationShips?.dependsOn?.length > 0) {
            for (var r = 0; r < baseProduct.relationShips.dependsOn.length; r++) {
              if ((baseProduct.relationShips.dependsOn[r].dependencyType && baseProduct.relationShips.dependsOn[r].dependencyType === 'Mandatory') || baseProduct.relationShips.dependsOn[r].cardinality.type === "Exact") {
                var dependerIndex = products.findIndex(item => item.id === baseProduct.relationShips.dependsOn[r].depender);
                if (dependerIndex > -1) {
                  if (products[dependerIndex].selected || products[dependerIndex].defaultSelected) {
                    return;
                  }
                }
              }
            }
          }
        }

        for (var j = 0; j < rules[i].addons.length; j++) {
          var addonIndex = products.findIndex(item => item.featureCode === rules[i].addons[j] && this.isDependerSelected(item));

          if (addonIndex > -1) {
            addonTotal += Number(quantityMap[rules[i].addons[j]]) || 0;
          }

          if (rules[i].addons.length === (j + 1)) {
            var activeStep = this.state.steps[this.state.activeStep];
            var itemIndex = products.findIndex(item => item.featureCode === rules[i].base);
            // if (products[itemIndex].componentType === activeStep.name) {
            //   products[itemIndex].quantity = addonTotal;
            //   this.setState({
            //     componentData: products
            //   })
            if (itemIndex > -1) {
              if (products[itemIndex].componentType === activeStep.name) {
                products[itemIndex].quantity = addonTotal;
                const baseItemForDeps = products[itemIndex];
                this.setState(
                  {
                    componentData: products,
                  },
                  () => {
                    this.selectDependentItems(baseItemForDeps);
                  },
                );
              }
            }
          }
        }
      }
    }
  }

  toggleProductDescription = () => {
    this.setState({
      showProductsDescription: !this.state.showProductsDescription
    }, () => {
      var componentData = structuredClone(this.state.componentData);
      for (var i = this.onChangePreQualData; i < componentData.length; i++) {
        componentData[i].expandDescription = this.state.showProductsDescription;
        if ((i + 1) === componentData.length) {
          this.setState({
            componentData
          })
        }
      }
    })
  }

  render() {
    const { t } = this.props;
    const { classes: jssClasses } = this.props;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                {/* <Breadcrumb list={this.state.bread} /> */}
                <h3
                  className={classes.customBreadcrumb}
                  style={{ margin: 0, fontWeight: "normal", float: "left" }}
                >
                  <span
                    onClick={() => {
                      this.props.router.navigate(-1);
                    }}
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                  >
                    {t("SOLUTIONS")}
                  </span>
                  <span style={{ margin: "0 8px" }}>{">"}</span>
                  <span
                    style={{
                      fontWeight: "bold",
                      color: this.props.tenantData.color,
                    }}
                  >
                    {this.state.name}
                  </span>
                </h3>
              </Grid>
              <Grid
                item
                align="right"
                size={{
                  xs: 6,
                }}
              >
                {this.state.subsciptionData &&
                  this.state.subsciptionData.subscriptionId && (
                    <h3
                      className={classes.customBreadcrumb}
                      style={{
                        margin: 0,
                        fontWeight: "normal",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: "bold",
                          color: this.props.tenantData.color,
                        }}
                      >
                        {t("Current Package")}:{" "}
                        {this.state.subsciptionData.productName}
                      </span>
                      <span style={{ color: "#424343", fontSize: "14px" }}>
                        {t("SUBSCRIPTION_ID")}:{" "}
                        {this.state.subsciptionData.subscriptionId}
                      </span>
                    </h3>
                  )}
                {this.state.customerDetails &&
                  this.state.customerDetails.accountName && (
                    <h3
                      className={classes.customBreadcrumb}
                      style={{ margin: 0, fontWeight: "normal" }}
                    >
                      {this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                        this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                        ? t("SELECT_SHIPPING_ADDRESS")
                        : t("SELECT_CUSTOMER")}
                      : &nbsp;
                      {this.state.quotedData &&
                        this.state.quotedData.productQuoted &&
                        this.state.quotedData.productQuoted.id ? (
                        <span
                          title={this.state.customerDetails.canonicalName}
                          style={{
                            fontWeight: "bold",
                            color: this.props.tenantData.color,
                          }}
                        >
                          {/* {this.state.customerDetails.canonicalName} */}
                          {this.state.customerDetails.childAccountName
                            ? this.state.customerDetails.childAccountName
                            : this.state.customerDetails.canonicalName}
                        </span>
                      ) : (
                        <span
                          title={this.state.customerDetails.canonicalName}
                          style={{
                            fontWeight: "bold",
                            color: this.props.tenantData.color,
                            cursor: "pointer",
                          }}
                          onClick={() => this.changeCustomer()}
                        >
                          {/* {this.state.customerDetails.canonicalName} */}
                          {this.state.customerDetails.childAccountName
                            ? this.state.customerDetails.childAccountName
                            : this.state.customerDetails.canonicalName}
                          {/* <Tooltip title={t('CHANGE')}> */}
                          <EditIcon
                            style={{
                              position: "absolute",
                              fontSize: "20px",
                              marginLeft: "5px",
                            }}
                          />
                          {/* </Tooltip> */}
                        </span>
                      )}
                    </h3>
                  )}
              </Grid>
            </Grid>
          </div>
        </div>
        <main>
          {this.state.renderView && (
            <>
              {/* <Grid container spacing={2}> */}
              {!this.state.showSteps ? (
                <Grid container spacing={2} className={classes.infoDiv}>
                  <>
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 12,
                      }}
                    >
                      <Paper
                        className={classes.card}
                        style={{ padding: "16px", borderRadius: "8px" }}
                        elevation={0}
                      >
                        <Grid container spacing={3}>
                          {this.state.showImage ? (
                            <>
                              <Grid
                                item
                                alignItems="center"
                                size={{
                                  xs: 12,
                                  md: 4,
                                }}
                              >
                                <Carousel
                                  images={this.state.images}
                                  color={this.props.tenantData.color}
                                />
                              </Grid>
                            </>
                          ) : (
                            <>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 2,
                                }}
                              ></Grid>
                            </>
                          )}
                          <Grid
                            item
                            className={classes.productCardDetails}
                            size={{
                              xs: 12,
                              md: 8,
                            }}
                          >
                            <Grid container spacing={3}>
                              <Grid
                                item
                                align="right"
                                size={{
                                  xs: 12,
                                }}
                              >
                                {/* <FormControl variant="outlined" className="custom-select-input" size={"small"} style={{ maxWidth: "150px" }}>
                                                                    <InputLabel id="language" htmlFor="outlined-age-native-simple">
                                                                        {" "}
                                                                        {t("SELECT_LANGUAGE") + " *"}
                                                                    </InputLabel>
                                                                    <SelectM
                                                                        native
                                                                        label="Select Language"
                                                                        labelId="language"
                                                                        value={this.state.language}
                                                                        onChange={(event) => this.onLanguageChange(event)}
                                                                        inputProps={{
                                                                            name: "language",
                                                                            id: "language",
                                                                        }}
                                                                    >
                                                                        <option value="en_US">{t("English")}</option>
                                                                        <option value="spanish">{t("Spanish")}</option>
                                                                        <option value="en_FR">{t("French")}</option>
                                                                    </SelectM>
                                                                </FormControl> */}
                              </Grid>
                              <Grid
                                item
                                align="left"
                                size={{
                                  xs: 12,
                                }}
                              >
                                <h2
                                  className={classes.itemName}
                                  style={{
                                    marginTop: "0",
                                    marginBottom: "12px",
                                  }}
                                >
                                  {this.state.name}
                                </h2>
                                <p
                                  className={classes.itemDescription}
                                  style={{ marginTop: "0" }}
                                >
                                  {this.state.description}
                                </p>
                              </Grid>
                            </Grid>

                            <Grid
                              container
                              spacing={2}
                              style={{ marginBottom: "4rem" }}
                            >
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 9,
                                }}
                              >
                                <div className={classes.itemPriceWrapper}>
                                  {(this.props.providerType ===
                                    "SALES_CHNL_PROVIDER" ||
                                    this.props.publicBrowsing) && (
                                      <>
                                        {this.state.isBundle && (
                                          <span
                                            className={classes.itemPriceLabel}
                                          >
                                            {t("STARTING_FROM_TEXT")}
                                          </span>
                                        )}
                                        <span
                                          className={classes.itemPrice}
                                          style={{
                                            color: this.props.tenantData.color,
                                          }}
                                        >
                                          {/* {`${currencyFormatter('', false)}${this.state.startingPrice ? (Math.round(this.state.startingPrice * 100) / 100).toFixed(2) : 0}`}{t('PER_MONTH')} */}
                                          {currencyFormatter(
                                            this.state.startingPrice
                                              ? this.state.startingPrice
                                              : 0,
                                          )}
                                          {t("PER_MONTH")}
                                        </span>
                                      </>
                                    )}
                                  {this.state.promos &&
                                    this.state.promos.length > 0 ? (
                                    <div style={{ marginTop: "10px" }}>
                                      <Select
                                        default={t("STANDARD_PRICING_OPTIONS")}
                                        options={this.state.promos}
                                        optionLabel={(item) => item.text}
                                        selected={
                                          this.state.selectedPromo
                                            ? this.state.selectedPromo.id
                                            : ""
                                        }
                                        name="selectedPromo"
                                        value={(item) => item.id}
                                        onChange={(e) => {
                                          this.onChangePromo(e);
                                        }}
                                        disabled={this.state.disableCreateQuote}
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              </Grid>
                              <Grid
                                item
                                size={{
                                  xs: 12,
                                  md: 9,
                                }}
                              >
                                <div
                                  className={classes.itemMainButtonWrapper}
                                  align="left"
                                >
                                  {this.state.showCheckAvailability && (
                                    <Button
                                      className={classes.itemMainButton}
                                      style={{ marginRight: 15 }}
                                      onClick={this.checkAvailability}
                                      disabled={this.state.disableCreateQuote}
                                    >
                                      {t("CHECK_AVAILABILITY")}
                                    </Button>
                                  )}
                                  {this.state.placeOrder && (
                                    <Button
                                      className={classes.itemMainButton}
                                      onClick={() => {
                                        this.verifyPromoBan();
                                      }}
                                      disabled={this.state.disableCreateQuote}
                                    >
                                      {this.props.providerType ===
                                        "SALES_CHNL_PROVIDER" ||
                                        this.props.publicBrowsing
                                        ? "Customize and Buy"
                                        : "Customize"}
                                    </Button>
                                  )}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Paper>
                    </Grid>
                    {(JSON.parse(this.state.overView).blocks[0].text.length >
                      0 ||
                      JSON.parse(this.state.techSpecs).blocks[0].text.length >
                      0 ||
                      JSON.parse(this.state.whatsIncluded).blocks[0].text
                        .length > 0) && (
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 12,
                          }}
                        >
                          <Paper
                            className={classes.card}
                            style={{ padding: "16px", borderRadius: "8px" }}
                            elevation={0}
                          >
                            <Detail
                              id={this.state.id}
                              overView={this.state.overView}
                              noOverview={this.state.noOverview}
                              techSpecs={this.state.techSpecs}
                              noTechspecs={this.state.noTechspecs}
                              whatsIncluded={this.state.whatsIncluded}
                              noWhatsincluded={this.state.noWhatsincluded}
                            />
                          </Paper>
                        </Grid>
                      )}
                  </>
                </Grid>
              ) : (
                <Grid container spacing={0}>
                  <Grid
                    item
                    className={classes.quantityWrapper}
                    size={{
                      xs: 6,
                    }}
                    style={{ height: 48 }}
                  >
                    {this.state.showOfferingQty && (
                      <>
                        <span
                          style={{ verticalAlign: "sub", marginRight: ".5rem" }}
                        >
                          {t("QUANTITY")}
                        </span>
                        <Input
                          className={classes.quantityInput}
                          type="number"
                          min="1"
                          step="1"
                          value={this.state.quantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value)) {
                              this.changeQuantity(value);
                            }
                          }}
                          onBlur={(e) => {
                            this.validateOfferingQuantity()
                          }}
                          disabled={this.state.disableQuantityInput}
                        />
                      </>
                    )}
                  </Grid>
                  <Grid
                    item
                    align="right"
                    size={{
                      xs: 6,
                    }}
                    style={{ height: 48 }}
                  >
                    {/* <FormControlLabel
                      control={
                        <Switch
                          checked={this.state.showOfferingQuantity}
                          onChange={this.toggleOfferingQuantity}
                          name="showOfferingQuantity"
                        />
                      }
                      label={this.props.t("SHOW_OFFERING_QUANTITY")}
                    /> */}

                    <FormControlLabel
                      control={
                        <Switch
                          checked={!this.state.hideAutoSelectedProducts}
                          onChange={() => this.setState({ openResetProductsDialog: true })}
                          name="hideAutoSelectedProducts"
                        />
                      }
                      label={this.props.t("SOOW_AUTO_SELECTED_CATEGORIES")}
                    />
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                    }}
                  >
                    {this.state.isBundle && (
                      <StepperNew
                        activeStep={this.state.activeStep}
                        steps={this.state.steps}
                        onStepSelect={this.changeStep}
                        back={this.goBackToTab}
                      />
                    )}
                  </Grid>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 12,
                    }}
                  >
                    <Paper
                      className={classes.card}
                      style={{ padding: "16px", borderRadius: "8px" }}
                      elevation={0}
                    >
                      <>
                        {/* {this.state.showImage && (
															<>
																<Grid item xs={12} md={4}>
																	<Carousel images={this.state.images} color={this.props.tenantData.color} />
																</Grid>
															</>
														)}
														{this.state.showImage ? "" : <Grid item xs={12} md={2}></Grid>} */}
                        <Grid
                          item
                          size={{
                            xs: 12,
                            md: 12,
                          }}
                        >
                          <Grid container spacing={2}>
                            <Grid
                              item
                              size={{
                                xs: 12,
                                md: 8,
                              }}
                            >
                              {this.state.activeStep === 0 &&
                                this.state.steps &&
                                this.state.steps.length > 0 &&
                                this.state.steps[0].label === "Package" ? (
                                <>
                                  <h2
                                    className={classes.itemName}
                                    style={{
                                      marginTop: "0",
                                      marginBottom: "0",
                                    }}
                                  >
                                    Select Package
                                  </h2>
                                  <div style={{ color: "#717784" }}>
                                    Select at least one from the package options
                                    below.
                                  </div>
                                </>
                              ) : (
                                <>
                                  <h2
                                    className={classes.itemName}
                                    style={{
                                      marginTop: "0",
                                      marginBottom: "0",
                                    }}
                                  >
                                    Select add-ons
                                  </h2>
                                  <div style={{ color: "#717784" }}>
                                    Add ons are optional, you can proceed
                                    without selecting. Mandatory add-ons will
                                    automatically be selected.
                                  </div>
                                </>
                              )}
                            </Grid>
                            <Grid item size={{ xs: 12, md: 4 }} align="right">
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={this.state.showProductsDescription}
                                    onChange={() => this.toggleProductDescription()}
                                    name="showProductsDescription"
                                  />
                                }
                                label={this.props.t("SHOW_PRODUCTS_DESCRIPTION")}
                              />
                            </Grid>
                          </Grid>
                          {/* <Grid container spacing={2}>
                                                        <Grid item xs={9}>
                                                            <h2 className={classes.itemName} style={{ marginTop: "0" }}>
                                                                {this.state.name}
                                                            </h2>
                                                            <div>
                                                                <>
                                                                    <Grid container spacing={0} justifyContent="center">
                                                                        <Grid item xs={6} className={classes.quantityWrapper}>
                                                                            <span style={{ verticalAlign: 'sub' }}>{t("QUANTITY")}&nbsp;:&nbsp;</span>
                                                                            <Input
                                                                                className={classes.quantityInput}
                                                                                type="number"
                                                                                min="1"
                                                                                step="1"
                                                                                value={this.state.quantity}
                                                                                onChange={(e) => {
                                                                                    this.changeQuantity(e.target.value);
                                                                                }}
                                                                                disabled={this.state.disableQuantityInput}
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={6} align="right"></Grid>
                                                                    </Grid>
                                                                </>
                                                            </div>

                                                        </Grid>
                                                        <Grid item xs={3} align="right">
                                                            <FormControl variant="outlined" className="custom-select-input" size={"small"} style={{ maxWidth: "150px" }}>
                                                                <InputLabel id="language" htmlFor="outlined-age-native-simple">
                                                                    {" "}
                                                                    {t("SELECT_LANGUAGE") + " *"}
                                                                </InputLabel>
                                                                <SelectM
                                                                    label="Select Language"
                                                                    native
                                                                    labelId="language"
                                                                    value={this.state.language}
                                                                    onChange={(event) => this.onLanguageChange(event)}
                                                                    inputProps={{
                                                                        name: "language",
                                                                        id: "language",
                                                                    }}
                                                                >
                                                                    <option value="en_US">{t("English")}</option>
                                                                    <option value="spanish">{t("Spanish")}</option>
                                                                    <option value="en_FR">{t("French")}</option>
                                                                </SelectM>
                                                            </FormControl>
                                                        </Grid>
                                                    </Grid> */}
                          {/* {this.state.isBundle && (
                                                        <StepperNew
                                                            activeStep={this.state.activeStep}
                                                            steps={this.state.steps}
                                                            onStepSelect={this.changeStep}
                                                            back={this.goBackToTab}
                                                        />
                                                    )} */}

                          <div>
                            <div>
                              <Grid
                                item
                                style={{ marginTop: "1rem" }}
                                size={{
                                  xs: 12,
                                  md: 8,
                                }}
                              >
                                {this.state.sortedComponentList.map(
                                  (comp, i) => (
                                    <React.Fragment key={i}>
                                      {i === this.state.activeStep && (
                                        <>
                                          {[...this.state.componentData].sort((a, b) =>
                                            a.displaySequence >
                                              b.displaySequence
                                              ? 1
                                              : b.displaySequence >
                                                a.displaySequence
                                                ? -1
                                                : 0,
                                          )
                                            .map((item) => (
                                              <React.Fragment key={item.id}>
                                                {comp.id ===
                                                  item.componentType && (
                                                    <>
                                                      {(this.state.activeStep ===
                                                        0 ||
                                                        item.defaultSelected ||
                                                        this.isDependerSelected(
                                                          item,
                                                        )) &&
                                                        item.customerViewable && (
                                                          <InlineItem
                                                            item={item}
                                                            updateComponentSelection={
                                                              this
                                                                .updateComponentSelection
                                                            }
                                                            componentData={
                                                              this.state
                                                                .componentData
                                                            }
                                                            changeComponentQuantity={
                                                              this
                                                                .changeComponentQuantity
                                                            }
                                                            bucketsList={
                                                              this.state
                                                                .sortedComponentList
                                                            }
                                                            activeStep={
                                                              this.state
                                                                .activeStep
                                                            }
                                                            updateComponentVariantSelection={
                                                              this
                                                                .updateComponentVariantSelection
                                                            }
                                                            productId={
                                                              this.state.id
                                                            }
                                                            selectedPromo={
                                                              this.state
                                                                .selectedPromo
                                                            }
                                                            providerType={
                                                              this.props
                                                                .providerType
                                                            }
                                                            updateAssemblyVariantsSelection={
                                                              this
                                                                .updateAssemblyVariantsSelection
                                                            }
                                                            publicBrowsing={
                                                              this.props
                                                                .publicBrowsing
                                                            }
                                                            isBundle={
                                                              this.state.isBundle
                                                            }
                                                            openProductSpecification={
                                                              this
                                                                .openProductSpecification
                                                            }
                                                            handleCharacteristicsUpdate={
                                                              this
                                                                .handleCharacteristicsUpdate
                                                            }
                                                            setShowChar={
                                                              this.setShowChar
                                                            }
                                                            hasMatchingDependency={
                                                              this.hasMatchingDependency(item)
                                                            }
                                                            showProductsDescription={this.state.showProductsDescription}
                                                          />
                                                        )}
                                                    </>
                                                  )}
                                              </React.Fragment>
                                            ))}
                                        </>
                                      )}
                                    </React.Fragment>
                                  ),
                                )}
                              </Grid>
                              {this.state.showAuxiliaryBucket &&
                                this.state.sortedComponentList.length - 1 ===
                                this.state.activeStep ? (
                                <Grid
                                  item
                                  size={{
                                    xs: 12,
                                    md: 8,
                                  }}
                                >
                                  <Autocomplete
                                    multiple
                                    options={this.state.auxiliaryProducts}
                                    groupBy={(option) => option.componentName}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) =>
                                      option.internalName
                                    }
                                    renderTags={(values) =>
                                      values.map((value) => (
                                        <Chip
                                          key={value.id}
                                          label={value.internalName}
                                          className={classes.auxiliaryChip}
                                        />
                                      ))
                                    }
                                    getOptionSelected={(option, value) =>
                                      option.id === value.id
                                    }
                                    renderOption={(option, { selected }) => (
                                      <React.Fragment>
                                        <Checkbox
                                          icon={icon}
                                          checkedIcon={checkedIcon}
                                          style={{ marginRight: 8 }}
                                          checked={selected}
                                        />
                                        <b>
                                          {option.internalName}
                                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                          {currencyFormatter(
                                            option.price
                                              ? option.price != "0"
                                                ? option.price
                                                : ""
                                              : "",
                                          )}{" "}
                                          /{" "}
                                          {option.priceType !== "RC"
                                            ? option.priceType
                                            : option.priceTenure
                                              ? option.priceTenure > 1
                                                ? "(" +
                                                "per " +
                                                option.priceTenure +
                                                " " +
                                                this.getPriceTenureUOM(
                                                  option.priceTenureUOM,
                                                ) +
                                                "s" +
                                                ")"
                                                : "(" +
                                                "per " +
                                                this.getPriceTenureUOM(
                                                  option.priceTenureUOM,
                                                ) +
                                                ")"
                                              : ""}
                                        </b>
                                      </React.Fragment>
                                    )}
                                    onChange={(event, value) =>
                                      this.selectedAuxiliaryProduct(
                                        event,
                                        value,
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder={t(
                                          "SELECT_AUXILIARY_PRODUCTS",
                                        )}
                                        className={classes.auxiliarySearch}
                                      />
                                    )}
                                  />
                                </Grid>
                              ) : (
                                this.state.availableItemCount === 0 &&
                                this.state.isBundle && (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontSize: "18px",
                                      height: "100px",
                                      lineHeight: "100px",
                                    }}
                                  >
                                    {t(
                                      "NO_ITEMS_AVAILABLE_FOR_THIS_CONFIGURATION",
                                    )}
                                  </div>
                                )
                              )}
                            </div>
                            <div className={classes.mainDiv}>
                              <div style={{ display: "flex" }}>
                                {this.state.isBundle && (
                                  <div
                                    // onClick={this.resetWizard}
                                    onClick={() => this.setState({ openResetConfirmDialog: true })}
                                    style={{
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                    className="tertiaryButton"
                                  >
                                    <svg
                                      width="16"
                                      height="16"
                                      viewBox="0 0 16 16"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M11.7716 4.22893C9.68876 2.14613 6.31189 2.14613 4.22909 4.22893C3.49043 4.96759 3.01458 5.86721 2.79969 6.81434C2.71822 7.17341 2.36109 7.39844 2.00203 7.31697C1.64297 7.2355 1.41793 6.87838 1.4994 6.51932C1.76833 5.33407 2.36458 4.20782 3.28628 3.28612C5.88978 0.682622 10.1109 0.682622 12.7144 3.28612C13.2464 3.81811 13.6672 4.26356 14.0003 4.63589V2.66683C14.0003 2.29864 14.2988 2.00016 14.667 2.00016C15.0352 2.00016 15.3337 2.29864 15.3337 2.66683V6.66683C15.3337 7.03502 15.0352 7.3335 14.667 7.3335H10.667C10.2988 7.3335 10.0003 7.03502 10.0003 6.66683C10.0003 6.29864 10.2988 6.00016 10.667 6.00016H13.4175C13.0761 5.58887 12.5571 5.01451 11.7716 4.22893ZM13.9986 8.68335C14.3577 8.76482 14.5827 9.12194 14.5012 9.48101C14.2323 10.6663 13.6361 11.7925 12.7144 12.7142C10.1109 15.3177 5.88978 15.3177 3.28628 12.7142C2.75429 12.1822 2.33349 11.7368 2.00033 11.3644V13.3335C2.00033 13.7017 1.70185 14.0002 1.33366 14.0002C0.965469 14.0002 0.666992 13.7017 0.666992 13.3335V9.3335C0.666992 8.96531 0.965469 8.66683 1.33366 8.66683H5.33366C5.70185 8.66683 6.00033 8.96531 6.00033 9.3335C6.00033 9.70169 5.70185 10.0002 5.33366 10.0002H2.58319C2.9245 10.4115 3.44351 10.9858 4.22909 11.7714C6.31189 13.8542 9.68876 13.8542 11.7716 11.7714C12.5102 11.0327 12.9861 10.1331 13.201 9.18598C13.2824 8.82692 13.6396 8.60188 13.9986 8.68335Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                    <span style={{ marginLeft: "6px" }}>
                                      {t("RESET")}
                                    </span>
                                  </div>
                                  // <Button onClick={this.resetWizard} style={{ marginLeft: 0 }}>
                                  // 	{t("RESET")}
                                  // </Button>
                                )}
                              </div>
                              <div>
                                {this.state.hasInfo && (
                                  <Button
                                    onClick={this.goBack}
                                    className="buttonSecondary"
                                  >
                                    {t("BACK")}
                                  </Button>
                                )}
                                {this.state.sortedComponentList.length - 1 ===
                                  this.state.activeStep ? (
                                  (this.props.providerType ===
                                    "SALES_CHNL_PROVIDER" ||
                                    this.props.router.location.pathname.includes(
                                      "newOrder",
                                    ) ||
                                    this.props.publicBrowsing) && (
                                    <>
                                      {this.state.subsciptionData &&
                                        this.state.subsciptionData.mode ? (
                                        <>
                                          {this.props.quoteEnabled && (
                                            <Button onClick={this.createQuoute}>
                                              {/* {t('CREATE_CHANGE_SUBSCRIPTION_QUOTE')} */}
                                              {t("ADD_TO_QUOTE")}
                                            </Button>
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {this.state.quotedData &&
                                            this.state.quotedData.productQuoted &&
                                            this.state.quotedData.productQuoted
                                              .id ? (
                                            <>
                                              <Button
                                                onClick={this.checkForChanges}
                                              >
                                                {t("GO_TO_QUOTE")}
                                              </Button>
                                              <Button
                                                onClick={this.createQuoute}
                                              >
                                                {t("UPDATE_TO_QUOTE")}
                                              </Button>
                                            </>
                                          ) : (
                                            <>
                                              {this.state.modules &&
                                                this.state.modules
                                                  .module_quote !=
                                                "enabled" && (
                                                  // this.state.allowedSate && this.state.allowedSate.includes(this.state.state)) && (
                                                  <Button
                                                    onClick={
                                                      this.createCartObject
                                                    }
                                                  >
                                                    <svg
                                                      width="17"
                                                      height="15"
                                                      viewBox="0 0 13 12"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      style={{
                                                        marginRight: "6px",
                                                        verticalAlign: "sub",
                                                      }}
                                                    >
                                                      <g clipPath="url(#clip0_36_5803)">
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M2.48535 1.50001H1.95508C1.67894 1.50001 1.45508 1.27615 1.45508 1.00001C1.45508 0.723863 1.67894 0.500006 1.95508 0.500006H2.5793C2.58292 0.500006 2.5866 0.500004 2.59033 0.500003C2.64651 0.499981 2.71428 0.499955 2.77426 0.504725C2.84429 0.510295 2.94332 0.524533 3.04814 0.575493C3.18483 0.641948 3.29811 0.748366 3.37296 0.880649C3.43036 0.982087 3.45075 1.08003 3.46067 1.14958C3.46918 1.20914 3.47338 1.27678 3.47686 1.33285C3.47709 1.33658 3.47732 1.34025 3.47755 1.34386L3.51855 2.00001L11.5207 2C11.5868 1.99998 11.6641 1.99995 11.7316 2.0057C11.8087 2.01226 11.9219 2.0292 12.0382 2.09342C12.1869 2.17546 12.3032 2.30549 12.3684 2.46224C12.4193 2.58495 12.4237 2.69938 12.4217 2.77666C12.4199 2.84443 12.4114 2.9213 12.4041 2.98694L12.1082 5.6498C12.0819 5.88619 12.0591 6.0914 12.027 6.26023C11.9928 6.43941 11.9419 6.61542 11.8398 6.78237C11.6864 7.03331 11.4626 7.23362 11.1963 7.35838C11.0191 7.44138 10.8385 7.47256 10.6567 7.4867C10.4853 7.50002 10.2788 7.50001 10.041 7.50001H3.8623L3.9248 8.50001H10.4551C10.7312 8.50001 10.9551 8.72386 10.9551 9.00001C10.9551 9.27615 10.7312 9.50001 10.4551 9.50001L3.81984 9.50001C3.76366 9.50003 3.69588 9.50006 3.6359 9.49529C3.56587 9.48972 3.46684 9.47548 3.36202 9.42452C3.22533 9.35806 3.11205 9.25165 3.0372 9.11936C2.9798 9.01793 2.95941 8.91998 2.94948 8.85043C2.94098 8.79087 2.93678 8.72323 2.9333 8.66716C2.93307 8.66343 2.93284 8.65976 2.93261 8.65615L2.48535 1.50001ZM2.47949 1.40624L2.52291 1.40353C2.53884 1.42401 2.55787 1.44188 2.5793 1.45651C2.58933 1.46335 2.59989 1.46949 2.61091 1.47484C2.63679 1.48743 2.65979 1.49441 2.67624 1.49815C2.6885 1.50094 2.6961 1.50168 2.6961 1.50168L2.69498 1.50158M3.7998 6.50001H10.023C10.284 6.50001 10.4512 6.49966 10.5792 6.48971C10.7009 6.48024 10.7477 6.46422 10.7721 6.4528C10.8609 6.41121 10.9355 6.34444 10.9866 6.2608C11.0007 6.23783 11.0218 6.19306 11.0446 6.07309C11.0686 5.94703 11.0875 5.78085 11.1163 5.52148L11.3964 3.00001H3.58105L3.7998 6.50001ZM3.95508 10.75C3.95508 10.3358 4.29086 10 4.70508 10C5.11929 10 5.45508 10.3358 5.45508 10.75C5.45508 11.1642 5.11929 11.5 4.70508 11.5C4.29086 11.5 3.95508 11.1642 3.95508 10.75ZM8.45508 10.75C8.45508 10.3358 8.79086 10 9.20508 10C9.61929 10 9.95508 10.3358 9.95508 10.75C9.95508 11.1642 9.61929 11.5 9.20508 11.5C8.79086 11.5 8.45508 11.1642 8.45508 10.75Z"
                                                          fill="currentColor"
                                                        />
                                                      </g>
                                                      <defs>
                                                        <clipPath id="clip0_36_5803">
                                                          <rect
                                                            width="12"
                                                            height="12"
                                                            fill="white"
                                                            transform="translate(0.955078)"
                                                          />
                                                        </clipPath>
                                                      </defs>
                                                    </svg>
                                                    {t("ADD_TO_CART")}
                                                  </Button>
                                                )}
                                              {this.state.modules &&
                                                this.state.modules
                                                  .module_quote ===
                                                "enabled" && (
                                                  // this.state.allowedSate && this.state.allowedSate.includes(this.state.state)) && (
                                                  <Button
                                                    onClick={this.createQuoute}
                                                  >
                                                    <svg
                                                      width="17"
                                                      height="17"
                                                      viewBox="0 0 17 17"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      style={{
                                                        verticalAlign: "sub",
                                                        marginRight: "6px",
                                                      }}
                                                    >
                                                      <g clipPath="url(#clip0_395_13150)">
                                                        <path
                                                          fillRule="evenodd"
                                                          clipRule="evenodd"
                                                          d="M8.38883 2.70957C8.25322 2.67702 8.10142 2.67273 7.58051 2.67273L4.90599 2.67273C4.5378 2.67273 4.23933 2.37425 4.23933 2.00606C4.23933 1.63787 4.5378 1.3394 4.90599 1.3394L7.58051 1.3394C7.60345 1.3394 7.62608 1.33939 7.64843 1.33938C8.07176 1.33917 8.39162 1.33902 8.70009 1.41308C8.97218 1.4784 9.2323 1.58615 9.47089 1.73236C9.74137 1.89811 9.96744 2.12439 10.2666 2.42387C10.2824 2.43968 10.2984 2.4557 10.3147 2.47192L15.3774 7.53466C15.6377 7.79501 15.6377 8.21712 15.3774 8.47747C15.117 8.73782 14.6949 8.73782 14.4346 8.47747L9.37185 3.41473C9.0035 3.04639 8.89314 2.94208 8.77423 2.86921C8.65493 2.79611 8.52487 2.74223 8.38883 2.70957ZM7.50934 5.02448C7.45046 5.01035 7.38019 5.00606 7.02234 5.00606H5.03933C4.65496 5.00606 4.40677 5.00658 4.21788 5.02202C4.03677 5.03681 3.96963 5.06193 3.93667 5.07873C3.81122 5.14264 3.70924 5.24463 3.64532 5.37007C3.62853 5.40303 3.60341 5.47018 3.58861 5.65129C3.57318 5.84018 3.57266 6.08836 3.57266 6.47273L3.57266 7.78907C3.57266 8.14693 3.57694 8.2172 3.59108 8.27608C3.60741 8.3441 3.63435 8.40913 3.6709 8.46878C3.70254 8.52041 3.7492 8.57312 4.00224 8.82617L9.20224 14.0262C9.47403 14.298 9.64988 14.4731 9.79436 14.5957C9.93289 14.7133 9.99813 14.7431 10.0333 14.7545C10.1672 14.798 10.3114 14.798 10.4453 14.7545C10.4805 14.7431 10.5458 14.7133 10.6843 14.5957C10.8288 14.4731 11.0046 14.298 11.2764 14.0262L12.9261 12.3765C13.1979 12.1047 13.373 11.9288 13.4957 11.7844C13.6133 11.6458 13.643 11.5806 13.6544 11.5454C13.6979 11.4115 13.6979 11.2673 13.6544 11.1334C13.643 11.0982 13.6133 11.033 13.4957 10.8944C13.373 10.75 13.1979 10.5741 12.9261 10.3023L8.05943 5.43564C7.80639 5.1826 7.75367 5.13594 7.70204 5.1043C7.64239 5.06775 7.57736 5.04082 7.50934 5.02448ZM7.07787 3.6727C7.34914 3.67244 7.5883 3.67222 7.8206 3.72799C8.02467 3.77698 8.21976 3.85779 8.39871 3.96745C8.6024 4.09227 8.77135 4.26154 8.96299 4.45353C8.97596 4.46653 8.98904 4.47963 9.00224 4.49283L13.887 9.37764C14.1356 9.62614 14.35 9.84052 14.5121 10.0315C14.6833 10.2331 14.835 10.4521 14.9225 10.7214C15.053 11.1231 15.053 11.5557 14.9225 11.9574C14.835 12.2267 14.6833 12.4457 14.5121 12.6473C14.35 12.8383 14.1356 13.0526 13.8871 13.3011L12.201 14.9872C11.9526 15.2357 11.7382 15.45 11.5472 15.6122C11.3456 15.7833 11.1266 15.9351 10.8574 16.0226C10.4557 16.1531 10.023 16.1531 9.62129 16.0226C9.35204 15.9351 9.13305 15.7833 8.93146 15.6122C8.74046 15.45 8.5261 15.2357 8.27762 14.9872L3.05943 9.76897C3.04623 9.75578 3.03313 9.7427 3.02013 9.72973C2.82814 9.53809 2.65887 9.36914 2.53405 9.16544C2.42439 8.9865 2.34358 8.79141 2.29459 8.58734C2.23882 8.35504 2.23904 8.11587 2.23929 7.84461C2.23931 7.82625 2.23933 7.80774 2.23933 7.78907L2.23933 6.44704C2.23931 6.0956 2.2393 5.79243 2.25971 5.54271C2.28124 5.27915 2.32878 5.017 2.45731 4.76475C2.64906 4.38843 2.95502 4.08246 3.33134 3.89072C3.5836 3.76219 3.84574 3.71464 4.10931 3.69311C4.35902 3.67271 4.6622 3.67272 5.01363 3.67273L7.02234 3.67273C7.041 3.67273 7.05951 3.67271 7.07787 3.6727Z"
                                                          fill="currentColor"
                                                        />
                                                      </g>
                                                      <defs>
                                                        <clipPath id="clip0_395_13150">
                                                          <rect
                                                            width="16"
                                                            height="16"
                                                            fill="white"
                                                            transform="translate(0.90625 0.672852)"
                                                          />
                                                        </clipPath>
                                                      </defs>
                                                    </svg>
                                                    {t("ADD_TO_QUOTE")}
                                                  </Button>
                                                )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )
                                ) : (
                                  <Button onClick={this.goNext}>
                                    {t("NEXT")}
                                  </Button>
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                      </>
                    </Paper>
                  </Grid>
                </Grid>
              )}
              {this.state.showImage ? (
                ""
              ) : (
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 2,
                  }}
                ></Grid>
              )}
              {/* </Grid> */}
            </>
          )}
          {this.state.openVerifyDialog && (
            <PreQualificationVerification
              openVerifyDialog={this.state.openVerifyDialog}
              preQualsData={this.state.preQualsData}
              closeVerifyDialog={this.closeVerifyDialog}
              onChangePreQualData={this.onChangePreQualData}
              preQualMessage={this.state.preQualMessage}
              disableButton={this.state.placeOrder}
            />
          )}

          {/* Select customer */}
          {this.state.showSelectCustomer && (
            <Dialog
              maxWidth={"lg"}
              // PaperComponent={this.draggableDialogPaper}
              PaperComponent={DraggableResizablePaper}
              fullWidth={true}
              open={this.state.showSelectCustomer}
              aria-labelledby="import-dialog-title"
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>
                    {this.props.loggedInUserType === "ECOMMERCE_CUSTOMER" ||
                      this.props.loggedInUserType === "ECOMMERCE_ADMIN"
                      ? t("SELECT_SHIPPING_ADDRESS")
                      : t("SELECT_CUSTOMER")}
                  </span>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "1rem",
                    }}
                  >
                    {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                      (this.props.loggedInUserType !== "ECOMMERCE_CUSTOMER" ||
                        this.props.loggedInUserType !== "ECOMMERCE_ADMIN") && (
                        <Button
                          style={{ float: "right" }}
                          onClick={() => {
                            this.setState({
                              showSelectCustomer: false,
                              showNewCustomer: true,
                            });
                          }}
                        >
                          <span
                            style={{
                              marginRight: ".5rem",
                              verticalAlign: "middle",
                            }}
                          >
                            <PlusIcon />
                          </span>
                          {t("ADD_CUSTOMER")}
                        </Button>
                      )}
                    <span>
                      <Tooltip title={t("CLOSE")}>
                        <IconButton
                          onTouchStart={this.closeDialog}
                          onClick={this.closeDialog}
                          aria-label="close"
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </span>
                  </span>
                </div>
              </DialogTitle>
              {this.state.err && (
                <div className={classes.errorBanner}>
                  <span
                    className={classes.errorMessage}
                    style={{ color: "color: #D8210E", fontWeight: "600" }}
                  >
                    {this.state.err}
                  </span>
                </div>
              )}
              <DialogContent dividers style={{ height: "550px" }}>
                <ManageCustomersHierarchy
                  screen="checkout"
                  subScreen="product"
                  stage={this.state.stage}
                  next={this.selectCustomerClose}
                  // back={this.back}
                  selectedTreeItems={this.state.selectedTreeItems}
                  customerDetails={this.state.customerDetails}
                  selectedPaymentMethod={this.state.selectedPaymentMethod}
                  resetSelecteddata={this.resetSelecteddata}
                  closeDialog={this.closeDialog}
                  parentTenantId={this.state.parentTenantId}
                  // offeringCustomer={(this.props.ecommerceCustData && this.props.ecommerceCustData.partyId) ? this.props.ecommerceCustData.partyId : this.state.offeringCustomer}
                  offeringCustomer={
                    this.props.ecommerceCustData &&
                      this.props.ecommerceCustData.partyId
                      ? [this.props.ecommerceCustData.partyId]
                      : this.state.offeringCustomersList
                  }
                  setSelectCallback={this.setSelectCustomerCallback}
                />
              </DialogContent>
              <DialogActions>
                <Button className='buttonSecondary' onClick={this.closeDialog}>{t("CANCEL")}</Button>
                <Button onClick={() => this.onSelectCustomerCallback && this.onSelectCustomerCallback()}>{t("SELECT")}</Button>
              </DialogActions>
            </Dialog>
          )}
          {this.state.showNewCustomer && (
            <Dialog
              maxWidth={"lg"}
              // PaperComponent={this.draggableDialogPaper}
              PaperComponent={DraggableResizablePaper}
              fullWidth={true}
              open={this.state.showNewCustomer}
              aria-labelledby="import-dialog-title"
              PaperProps={
                {
                  // className: jssClasses.resizablePaper
                }
              }
            >
              <DialogTitle id="draggableDialogPaper" style={{ cursor: "move" }}>
                {t("ADD_NEW_CUSTOMER")}
              </DialogTitle>
              <DialogContent dividers>
                <CustomerDetails
                  manageCustomer={true}
                  close={this.removeCustomerForm}
                  addCustomer={this.addCustomer}
                  validator={this.closeErrorMessage}
                  customerDetails={this.state.newCustomerDetails}
                />
              </DialogContent>
            </Dialog>
          )}

          {/* showChangesWarning */}
          <Dialog
            disableScrollLock={true}
            maxWidth={"sm"}
            fullWidth={true}
            open={this.state.showChangesWarning}
            aria-labelledby="delete-dialog-title"
            PaperProps={
              {
                // className: jssClasses.resizablePaper
              }
            }
          >
            <DialogTitle id="delete-dialog-title">
              <div style={{ display: "flex" }}>
                <span style={{ display: "inline-flex", width: "95%" }}>
                  {t("UNSAVED_CHANGES")}
                </span>
                <Tooltip title={t("CLOSE")}>
                  <IconButton
                    onTouchStart={() => this.closeChangesWarning(true)}
                    onClick={() => this.closeChangesWarning(true)}
                    aria-label="close"
                  >
                    <CloseIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </DialogTitle>
            <DialogContent dividers>
              <DialogContentText>
                {t("UNSAVED_OLD_QUOTE_CHANGES")}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={(event) => this.closeChangesWarning(true)}
                color="primary"
              >
                {t("NO")}
              </Button>
              <Button
                onClick={(event) => this.closeChangesWarning(false)}
                color="primary"
              >
                {t("YES")}
              </Button>
            </DialogActions>
          </Dialog>

          {/* Dialog box for confirmation to reset the selections */}

          <Dialog
            open={this.state.openResetConfirmDialog}
            disableScrollLock={true}
            maxWidth={"sm"}
            fullWidth={true}
          >
            <DialogTitle>
              {t("RESET_SELECTIONS")}
            </DialogTitle>

            <DialogContent dividers>
              <DialogContentText>
                {t('RESET_SELECTIONS_MESSAGE')}
              </DialogContentText>
            </DialogContent>

            <DialogActions>
              <Button
                onClick={() => this.setState({ openResetConfirmDialog: false })}
                className='buttonSecondary'
              >
                {t("CANCEL")}
              </Button>

              <Button
                onClick={this.resetWizard}
              >
                {t("RESET")}
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={this.state.openResetProductsDialog}
            disableScrollLock={true}
            maxWidth={"sm"}
            fullWidth={true}
          >
            <DialogTitle>
              Reset Wizard
            </DialogTitle>

            <DialogContent dividers>
              <DialogContentText>
                All your current selections and progress will be lost.
                Are you sure you want to continue?
              </DialogContentText>
            </DialogContent>

            <DialogActions>

              <Button
                onClick={() => this.setState({ openResetProductsDialog: false })}
                className='buttonSecondary'
              >
                {t('CANCEL')}
              </Button>

              <Button
                onClick={() => {
                  this.setState({
                    hideAutoSelectedProducts: !this.state.hideAutoSelectedProducts,
                    openResetProductsDialog: false
                  }, () => {
                    this.resetWizard();
                    this.setProductData(this.state.componentTypeList, structuredClone(this.state.originalOfferingData));
                  });
                }}
                variant="contained"
                color="error"
              >
                {t('CONTINUE')}
              </Button>

            </DialogActions>
          </Dialog>

          {/* {this.state.showProductSpecification &&
                        <>
                            <OfferingProductSpecCharacteristicsExistingDialog t={t} open={this.state.showProductSpecification} productId={this.state.selectedProductSpecification.id} productName={this.state.selectedProductSpecification.name} onClose={this.handleCloseSpecificationDialog} componentProductCharacteristics={this.state.selectedProductSpecification.productSpec ? this.state.selectedProductSpecification.productSpec : {}} onCharacteristicsChange={this.handleCharacteristicsUpdate} changedCharacteristics={this.state.selectedCharacteristics || []} screen='checkout' />
                        </>
                    } */}

          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

// const jssStyles = {
//     resizablePaper: {
//         resize: 'both',
//         overflow: 'auto',
//         minWidth: 640,
//         minHeight: 200,
//         maxWidth: '90vw',
//         maxHeight: '90vh',
//         width: '80vw',
//     }
// }

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    cartList: state.cart.cartList,
    userName: state.auth.email,
    selectedPromoBan: state.cart.selectedPromoBan,
    tenantId: state.auth.tenantId,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    publicBrowsing: state.auth.publicBrowsing,
    loggedInUserType: state.auth.userLoginType,
    ecommerceCustData: state.auth.ecommerceCustData,
    shoppingCart: state.cart.shoppingCart,
    shoppingQuote: state.quote.shoppingQuote,
    quoteEnabled: state.auth.quoteEnabled,
    showOfferingQuantity: state.auth.showOfferingQuantity
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (sol, acc) =>
      dispatch({ type: actionTypes.ADD_TO_CART, sol, acc }),
    setErrorMessage: (errMsg, msgType, warning) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType, warning }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setPromoBan: (id) => dispatch({ type: actionTypes.CHECK_PROMO_BAN, id }),
    setCart: (cart) => dispatch({ type: actionTypes.SET_CART, cart }),
    setQuote: (data) => dispatch({ type: actionTypes.SET_QUOTE, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Product)));
